'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Symbol = require('@babel/runtime-corejs3/core-js-stable/symbol');
var _getIteratorMethod = require('@babel/runtime-corejs3/core-js/get-iterator-method');
var _Array$isArray = require('@babel/runtime-corejs3/core-js-stable/array/is-array');
var _typeof = require('@babel/runtime-corejs3/helpers/typeof');
var _toConsumableArray = require('@babel/runtime-corejs3/helpers/toConsumableArray');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');
var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _findInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/find');
var _Map = require('@babel/runtime-corejs3/core-js-stable/map');
var _Set = require('@babel/runtime-corejs3/core-js-stable/set');
var _filterInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/filter');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _Array$from = require('@babel/runtime-corejs3/core-js-stable/array/from');
var _reduceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/reduce');
var _indexOfInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/index-of');
var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
var _spliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/splice');
var _valuesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/values');
var lodash = require('lodash');
require('../data/index.js');
require('../error/index.js');
require('../expression/index.js');
var helperFunctions = require('../utils/helper-functions.js');
var patternAggregation_model = require('./pattern-aggregation.model.js');
var patternEdgeSet_model = require('./pattern-edge-set.model.js');
var patternOrderBy_model = require('./pattern-order-by.model.js');
var patternParam_model = require('./pattern-param.model.js');
var patternView_model = require('./pattern-view.model.js');
var patternVertexSet_model = require('./pattern-vertex-set.model.js');
var patternWidget_model = require('./pattern-widget.model.js');
var patternWidgetFactory_model = require('./pattern-widget-factory.model.js');
var triplet = require('./triplet.js');
var defaultOptionsList = require('../expression/default-options-list.js');
var config = require('./config.js');
require('../query-builder/index.js');
var graphStudioError_model = require('../error/graph-studio-error.model.js');
var parseJson = require('../expression/parse-json.js');
var condition_model = require('../expression/condition.model.js');
var expressionValidator = require('../expression/expression-validator.js');
var buildAliasSchema = require('../query-builder/build-alias-schema.js');
var expression_model = require('../expression/expression.model.js');
var dataType_enum = require('../data/data-type.enum.js');
var operators_enum = require('../expression/operators.enum.js');
var atom_model = require('../expression/atom.model.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Symbol__default = /*#__PURE__*/_interopDefaultLegacy(_Symbol);
var _getIteratorMethod__default = /*#__PURE__*/_interopDefaultLegacy(_getIteratorMethod);
var _Array$isArray__default = /*#__PURE__*/_interopDefaultLegacy(_Array$isArray);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);
var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _findInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_findInstanceProperty);
var _Map__default = /*#__PURE__*/_interopDefaultLegacy(_Map);
var _Set__default = /*#__PURE__*/_interopDefaultLegacy(_Set);
var _filterInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_filterInstanceProperty);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _Array$from__default = /*#__PURE__*/_interopDefaultLegacy(_Array$from);
var _reduceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_reduceInstanceProperty);
var _indexOfInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_indexOfInstanceProperty);
var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);
var _spliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_spliceInstanceProperty);
var _valuesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_valuesInstanceProperty);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof _Symbol__default["default"] && _getIteratorMethod__default["default"](r) || r["@@iterator"]; if (!t) { if (_Array$isArray__default["default"](r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { var _context281; if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = _sliceInstanceProperty__default["default"](_context281 = {}.toString.call(r)).call(_context281, 8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from__default["default"](r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var versionNumber = '3.3';

// TODO: Keep the list updated for each VQB release.
var patternJsonKeys = ['name', 'description', 'patternVertexSets', 'patternEdgeSets', 'patternWidgets', 'patternViews', 'version', 'filters', 'aggregations', 'postAggregationFilters', 'orderBy', 'skip', 'limit'];
var Pattern = /*#__PURE__*/function () {
  function Pattern(data, schema) {
    var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9;
    _classCallCheck__default["default"](this, Pattern);
    // Not used.
    _defineProperty__default["default"](this, "skip", 0);
    _defineProperty__default["default"](this, "limit", -1);
    _forEachInstanceProperty__default["default"](_context = _Object$keys__default["default"](data)).call(_context, function (key) {
      if (!_includesInstanceProperty__default["default"](patternJsonKeys).call(patternJsonKeys, key) && Pattern.checkIfValueHasData(data[key])) {
        throw new graphStudioError_model.GraphStudioError("Pattern ".concat(data.name, " contains unsupported features. ") + "Did you import a solution from a higher version of GraphStudio?");
      }
    });
    this.name = data.name;
    this.description = data.description || '';
    this.patternVertexSets = _mapInstanceProperty__default["default"](_context2 = data.patternVertexSets).call(_context2, function (patternVertexSet) {
      return new patternVertexSet_model.PatternVertexSet(patternVertexSet, schema);
    });
    this.patternEdgeSets = _mapInstanceProperty__default["default"](_context3 = data.patternEdgeSets).call(_context3, function (patternEdgeSet) {
      return new patternEdgeSet_model.PatternEdgeSet(patternEdgeSet, schema);
    });
    this.patternWidgets = _mapInstanceProperty__default["default"](_context4 = data.patternWidgets).call(_context4, function (patternWidget) {
      return new patternWidgetFactory_model.PatternWidgetFactory().getPatternWidget(patternWidget);
    });
    this.patternViews = _mapInstanceProperty__default["default"](_context5 = data.patternViews || []).call(_context5, function (patternView) {
      return new patternView_model.PatternView(patternView, schema);
    });
    this.version = data.version || '';

    // Not used.
    this.filters = _mapInstanceProperty__default["default"](_context6 = data.filters).call(_context6, function (filterJson) {
      return parseJson.parseExprJson(filterJson, schema);
    });
    this.aggregations = _mapInstanceProperty__default["default"](_context7 = data.aggregations).call(_context7, function (aggJson) {
      return new patternAggregation_model.PatternAggregation(aggJson, schema);
    });
    this.postAggregationFilters = _mapInstanceProperty__default["default"](_context8 = data.postAggregationFilters).call(_context8, function (postFilterJson) {
      return parseJson.parseExprJson(postFilterJson, schema);
    });
    this.orderBy = _mapInstanceProperty__default["default"](_context9 = data.orderBy).call(_context9, function (orderByJson) {
      return new patternOrderBy_model.PatternOrderBy(orderByJson, schema);
    });
    this.skip = data.skip;
    this.limit = data.limit;
  }

  /**
   * Helper function to check if the value of a patternJson attribute has data.
   * A value has data if it is not null, undefined, an empty list, or an empty object.
   *
   * @param {any} value
   * @return {boolean}
   * @memberof Pattern
   */
  return _createClass__default["default"](Pattern, [{
    key: "findComponentById",
    value:
    /**
     * Find the component within the pattern by id.
     *
     * @param {string} id
     * @returns {(PatternVertexSet | PatternEdgeSet | PatternWidget)}
     * @memberof Pattern
     */
    function findComponentById(id) {
      var _context10, _context11, _context12, _context13;
      return _findInstanceProperty__default["default"](_context10 = this.patternVertexSets).call(_context10, function (patternVertex) {
        return patternVertex.id === id;
      }) || _findInstanceProperty__default["default"](_context11 = this.patternEdgeSets).call(_context11, function (patternEdge) {
        return patternEdge.id === id;
      }) || _findInstanceProperty__default["default"](_context12 = this.patternWidgets).call(_context12, function (patternWidget) {
        return patternWidget.id === id;
      }) || _findInstanceProperty__default["default"](_context13 = this.patternViews).call(_context13, function (patternView) {
        return patternView.id === id;
      });
    }

    /**
     * Dump the pattern into JSON.
     *
     * @returns {PatternJson}
     * @memberof Pattern
     */
  }, {
    key: "toJson",
    value: function toJson() {
      var _context14, _context15, _context16, _context17, _context18, _context19, _context20, _context21;
      return {
        name: this.name,
        description: this.description,
        patternVertexSets: _mapInstanceProperty__default["default"](_context14 = this.patternVertexSets).call(_context14, function (patternVertexSet) {
          return patternVertexSet.toJson();
        }),
        patternEdgeSets: _mapInstanceProperty__default["default"](_context15 = this.patternEdgeSets).call(_context15, function (patternEdgeSet) {
          return patternEdgeSet.toJson();
        }),
        patternWidgets: _mapInstanceProperty__default["default"](_context16 = this.patternWidgets).call(_context16, function (patternWidget) {
          return patternWidget.toJson();
        }),
        patternViews: _mapInstanceProperty__default["default"](_context17 = this.patternViews).call(_context17, function (patternView) {
          return patternView.toJson();
        }),
        version: this.version,
        filters: _mapInstanceProperty__default["default"](_context18 = this.filters).call(_context18, function (filter) {
          return filter.toJson();
        }),
        aggregations: _mapInstanceProperty__default["default"](_context19 = this.aggregations).call(_context19, function (agg) {
          return agg.toJson();
        }),
        postAggregationFilters: _mapInstanceProperty__default["default"](_context20 = this.postAggregationFilters).call(_context20, function (postFilter) {
          return postFilter.toJson();
        }),
        orderBy: _mapInstanceProperty__default["default"](_context21 = this.orderBy).call(_context21, function (orderBy) {
          return orderBy.toJson();
        }),
        skip: this.skip,
        limit: this.limit
      };
    }

    /**
     * Generate corresponding GSQL script for the graph pattern.
     * FIXME: use templates.
     *
     * @param {Graph} graph
     * @returns {string}
     * @memberof Pattern
     */
  }, {
    key: "toGSQL",
    value: function toGSQL(graph) {
      var _context22,
        _this = this,
        _context83,
        _context84,
        _context85;
      var queryBlocks = [];
      var id2Block = new _Map__default["default"]();
      this.splitPatternIntoBlocks(queryBlocks, id2Block);

      // Store the parameters.
      var paramsDecl = this.collectParameters();

      // Store the tuple definitions.
      var tupleDefs = new _Set__default["default"]();
      // Store the accumulator declaration statements.
      var accumulatorsDecl = new _Set__default["default"]();

      // block2PatternViewIds[i] is a list of ids of the pattern views on the i-th block.
      var block2PatternViewIds = [];
      for (var i = 0; i < queryBlocks.length; i++) {
        block2PatternViewIds[i] = [];
      }
      _forEachInstanceProperty__default["default"](_context22 = this.patternViews).call(_context22, function (patternView) {
        var blockIndex = id2Block.get(patternView.vertexSetIds[0]);
        block2PatternViewIds[blockIndex].push(patternView.id);
      });
      var queryBody = '';

      // Handle each pattern block.
      _forEachInstanceProperty__default["default"](queryBlocks).call(queryBlocks, function (queryBlock, blockIndex) {
        var _context23, _context24, _context25;
        // Prepare the vertex set constraints.
        var constrainedVertexPatterns = new _Set__default["default"]();
        queryBody += _this.prepareVertexSetsInQueryBlock(queryBlock, accumulatorsDecl, constrainedVertexPatterns);

        // Retrieve all the vertex/edge patterns and pattern views on the current block.
        var vertexPatterns = _mapInstanceProperty__default["default"](_context23 = queryBlock.vertexPatternIds).call(_context23, function (pvId) {
          return _this.getPatternEntityById(pvId);
        });
        var edgePatterns = _mapInstanceProperty__default["default"](_context24 = queryBlock.edgePatternIds).call(_context24, function (peId) {
          return _this.getPatternEntityById(peId);
        });
        var patternViews = _mapInstanceProperty__default["default"](_context25 = block2PatternViewIds[blockIndex]).call(_context25, function (patternViewId) {
          return _this.getPatternEntityById(patternViewId);
        });

        // The vertex patterns that need to be output or is input of another widget
        // needs to be collected.
        var vertexPatternsToBeCollected = _filterInstanceProperty__default["default"](vertexPatterns).call(vertexPatterns, function (pv) {
          var _context26;
          return pv.output || _findInstanceProperty__default["default"](_context26 = _this.patternWidgets).call(_context26, function (pw) {
            var _context27;
            return _includesInstanceProperty__default["default"](_context27 = pw.inputPatternIds).call(_context27, pv.id);
          });
        });

        // Generate the SELECT clause. We select one vertex pattern with limit.
        // If no pattern has limit, we select one vertex pattern that needs to be output.
        var vertexPatternToBeSelected = _findInstanceProperty__default["default"](vertexPatterns).call(vertexPatterns, function (pv) {
          return pv.hasLimit;
        }) || vertexPatternsToBeCollected[0] || vertexPatterns[0];
        var selectClause = "  VertexSet_".concat(vertexPatternToBeSelected.id, " = \n        ") + "SELECT ".concat(_this.getPatternComponentAlias(vertexPatternToBeSelected), "\n");

        // Generate the FROM clause.
        var fromClause = _this.generateFromClause(queryBlock, graph, constrainedVertexPatterns);

        // Generate the WHERE clause.
        var whereClause = _this.generateWhereClause(queryBlock);

        // Generate the ACCUM statements that will be used to assemble the clauses later.
        var accumStatements = _this.generateAccumStatements(queryBlock, accumulatorsDecl);
        // Only accumulate the pattern view matching results on the final SELECT FROM clause of one block.
        var patternViewAccumStmts = [];

        // Handle pattern views.
        var patternViewPostProcessingStmts = '';
        _forEachInstanceProperty__default["default"](patternViews).call(patternViews, function (patternView) {
          var _context28, _context38, _context44, _context51;
          var tupleFields = {
            baseTypes: [],
            fieldNames: []
          };
          var vertexSetForLoopStmts = [];
          var vertexSetOutputStmts = [];

          // Handle each vertex set in the pattern view.
          _forEachInstanceProperty__default["default"](_context28 = patternView.vertexSetIds).call(_context28, function (vertexSetId) {
            var _context29, _context30, _context31, _context32, _context33;
            var vertexSet = _this.getPatternEntityById(vertexSetId);
            var vertexSetAlias = _this.getPatternComponentAlias(vertexSet);

            // Collect the vertex set info for pattern view tuple definition.
            // TODO: mark support for multi-type.
            tupleFields.baseTypes.push(_concatInstanceProperty__default["default"](_context29 = "vertex<".concat(vertexSet.vertices[0], "> ")).call(_context29, vertexSetAlias));
            tupleFields.fieldNames.push(vertexSetAlias);

            // Define a set accum for the vertex set.
            accumulatorsDecl.add(_concatInstanceProperty__default["default"](_context30 = _concatInstanceProperty__default["default"](_context31 = "SetAccum<vertex<".concat(vertexSet.vertices[0], ">> @@")).call(_context31, patternView.alias, "_")).call(_context30, vertexSetAlias));

            // Collect the vertex set matching results from the pattern view matching results.
            vertexSetForLoopStmts.push(_concatInstanceProperty__default["default"](_context32 = _concatInstanceProperty__default["default"](_context33 = "        @@".concat(patternView.alias, "_")).call(_context33, vertexSetAlias, " += result.")).call(_context32, vertexSetAlias, ";\n"));

            // Print the vertex set matching results.
            if (patternView.output) {
              var _context34, _context35, _context36, _context37;
              vertexSetOutputStmts.push(_concatInstanceProperty__default["default"](_context34 = _concatInstanceProperty__default["default"](_context35 = _concatInstanceProperty__default["default"](_context36 = "  ".concat(patternView.alias, "_")).call(_context36, vertexSetAlias, " = { @@")).call(_context35, patternView.alias, "_")).call(_context34, vertexSetAlias, " };\n") + "  ".concat(_this.getPrintStatement(vertexSet, _concatInstanceProperty__default["default"](_context37 = "".concat(patternView.alias, "_")).call(_context37, vertexSetAlias), graph, patternView.alias), "\n\n"));
            }
          });

          // Handle each edge set in the pattern view.
          _forEachInstanceProperty__default["default"](_context38 = patternView.edgeSetIds).call(_context38, function (edgeSetId) {
            var _context39;
            var edgeSet = _this.getPatternEntityById(edgeSetId);
            // Edge with kleen start cannot be collected.
            if (edgeSet.repeatAtLeast !== 1 || edgeSet.repeatAtMost !== 1) {
              return;
            }
            var edgeSetAlias = _this.getPatternComponentAlias(edgeSet);

            // Collect the edge set info for pattern view tuple definition.
            tupleFields.baseTypes.push(_concatInstanceProperty__default["default"](_context39 = "edge<".concat(edgeSet.edges[0], "> ")).call(_context39, edgeSetAlias));
            tupleFields.fieldNames.push(edgeSetAlias);
          });

          // If the pattern view has limit, dump the HeapAccum to the Result_PatternViewAlias.
          if (patternView.hasLimit) {
            var _context40, _context41, _context42;
            // Convert the HeapAccum into SetAccum.
            patternViewPostProcessingStmts += "  WHILE (@@OrderHeap_".concat(patternView.alias, ".size() > 0) DO\n") + _concatInstanceProperty__default["default"](_context40 = _concatInstanceProperty__default["default"](_context41 = "    @@Result_".concat(patternView.alias, " += Tuple_")).call(_context41, patternView.alias, "(")).call(_context40, _mapInstanceProperty__default["default"](_context42 = tupleFields.fieldNames).call(_context42, function (field) {
              var _context43;
              return _concatInstanceProperty__default["default"](_context43 = "@@OrderHeap_".concat(patternView.alias, ".top().")).call(_context43, field);
            }).join(', '), ");\n") + "    @@OrderHeap_".concat(patternView.alias, ".pop();\n") + "  END;\n";
          }
          if (patternView.output) {
            patternViewPostProcessingStmts += "  ".concat(_this.getPrintStatement(patternView, "@@Result_".concat(patternView.alias), graph), "\n\n");
          }
          patternViewPostProcessingStmts += "  FOREACH result IN @@Result_".concat(patternView.alias, " DO\n") + vertexSetForLoopStmts.join('') + "  END;\n\n" + vertexSetOutputStmts.join('');

          // With the info collected from all the vertex/edge sets, define a tuple for the pattern view.
          tupleDefs.add(_concatInstanceProperty__default["default"](_context44 = "TYPEDEF TUPLE<".concat(tupleFields.baseTypes.join(', '), "> Tuple_")).call(_context44, patternView.alias));
          // If the pattern view has limit, use another HeapAccum to collect top tuples during traversal.
          if (patternView.hasLimit) {
            var _context48, _context49, _context50;
            var heapTupleFields = {
              baseTypes: _toConsumableArray__default["default"](tupleFields.baseTypes),
              fieldNames: _toConsumableArray__default["default"](tupleFields.fieldNames)
            };
            var heapOrders = [];
            if (patternView.orderBy.length === 0) {
              heapTupleFields.baseTypes.push('int f0');
              heapTupleFields.fieldNames.push('f0');
              heapOrders.push('f0 ASC');
            } else {
              var _context45;
              _forEachInstanceProperty__default["default"](_context45 = patternView.orderBy).call(_context45, function (orderBy, i) {
                var _context46, _context47;
                heapTupleFields.baseTypes.push(_concatInstanceProperty__default["default"](_context46 = "".concat(_this.getExprDataType(orderBy.expression), " f")).call(_context46, i));
                heapTupleFields.fieldNames.push("f".concat(i));
                heapOrders.push(_concatInstanceProperty__default["default"](_context47 = "f".concat(i, " ")).call(_context47, orderBy.asc ? 'ASC' : 'DESC'));
              });
            }
            tupleDefs.add(_concatInstanceProperty__default["default"](_context48 = "TYPEDEF TUPLE<".concat(heapTupleFields.baseTypes.join(', '), "> OrderTuple_")).call(_context48, patternView.alias));
            accumulatorsDecl.add(_concatInstanceProperty__default["default"](_context49 = "HeapAccum<OrderTuple_".concat(patternView.alias, ">(")).call(_context49, patternView.limit, ", ") + _concatInstanceProperty__default["default"](_context50 = "".concat(heapOrders.join(', '), ") @@OrderHeap_")).call(_context50, patternView.alias));
          }
          // Define a set accumulator to collect the pattern view tuple.
          accumulatorsDecl.add(_concatInstanceProperty__default["default"](_context51 = "SetAccum<Tuple_".concat(patternView.alias, "> @@Result_")).call(_context51, patternView.alias));
          // Collect pattern view results in the ACCUM statements.
          if (patternView.hasLimit) {
            var _context52, _context53, _context54, _context55;
            // TODO: handle pattern view aggregation by extending this.getOrderByPureExpression
            var orderExprList = _mapInstanceProperty__default["default"](_context52 = patternView.orderBy).call(_context52, function (orderBy) {
              return _this.removeParamParenthesis(orderBy.expression.toString());
            });
            if (orderExprList.length === 0) {
              orderExprList.push('1');
            }
            patternViewAccumStmts.push(_concatInstanceProperty__default["default"](_context53 = _concatInstanceProperty__default["default"](_context54 = _concatInstanceProperty__default["default"](_context55 = "@@OrderHeap_".concat(patternView.alias, " += OrderTuple_")).call(_context55, patternView.alias, "(")).call(_context54, tupleFields.fieldNames.join(', '), ", ")).call(_context53, orderExprList.join(', '), ")"));
          } else {
            var _context56, _context57;
            patternViewAccumStmts.push(_concatInstanceProperty__default["default"](_context56 = _concatInstanceProperty__default["default"](_context57 = "@@Result_".concat(patternView.alias, " += Tuple_")).call(_context57, patternView.alias, "(")).call(_context56, tupleFields.fieldNames.join(', '), ")"));
          }
        });
        if (_filterInstanceProperty__default["default"](vertexPatterns).call(vertexPatterns, function (pv) {
          return pv.hasLimit;
        }).length === 0 && vertexPatternsToBeCollected.length <= 1) {
          var _context58;
          // Case 1. No vertex pattern has limit, at most one vertex pattern needs to be collected.
          // Only need one query block in this case.

          // Collect the edge sets.
          _forEachInstanceProperty__default["default"](_context58 = _filterInstanceProperty__default["default"](edgePatterns).call(edgePatterns, function (edgePattern) {
            return edgePattern.output;
          })).call(_context58, function (edgePattern) {
            var _context59;
            accumulatorsDecl.add("SetAccum<edge> @@EdgeSet_".concat(edgePattern.id));
            accumStatements.accumStmts.push(_concatInstanceProperty__default["default"](_context59 = "@@EdgeSet_".concat(edgePattern.id, " += ")).call(_context59, _this.getPatternComponentAlias(edgePattern)));
          });

          // Can skip the query block if the query block is ordinary,
          // and the vertex pattern is constrained by a previous block.
          if (!_this.isOrdinaryPattern(queryBlock) || !constrainedVertexPatterns.has(vertexPatternToBeSelected.id)) {
            var _accumStatements$accu, _context60;
            (_accumStatements$accu = accumStatements.accumStmts).push.apply(_accumStatements$accu, patternViewAccumStmts);

            // Get the query block.
            queryBody += _this.getQueryBlock(selectClause, fromClause, whereClause, accumStatements, vertexPatternToBeSelected) + '\n';

            // Output the edge sets.
            _forEachInstanceProperty__default["default"](_context60 = _filterInstanceProperty__default["default"](edgePatterns).call(edgePatterns, function (edgePattern) {
              return edgePattern.output;
            })).call(_context60, function (edgePattern) {
              queryBody += "  ".concat(_this.getPrintStatement(edgePattern, "@@EdgeSet_".concat(edgePattern.id), graph), "\n");
            });
          }

          // Output the selected vertex set if needed.
          if (vertexPatternToBeSelected.output) {
            queryBody += "\n  ".concat(_this.getPrintStatement(vertexPatternToBeSelected, "VertexSet_".concat(vertexPatternToBeSelected.id), graph), "\n\n");
          }
        } else if (_filterInstanceProperty__default["default"](vertexPatterns).call(vertexPatterns, function (pv) {
          return _includesInstanceProperty__default["default"](vertexPatternsToBeCollected).call(vertexPatternsToBeCollected, pv) || pv.hasLimit;
        }).length <= 1 && _filterInstanceProperty__default["default"](edgePatterns).call(edgePatterns, function (pe) {
          return pe.output;
        }).length === 0 && patternViews.length === 0) {
          var _accumStatements$accu2;
          // Case 2. If order-by and limit only happens on the selected vertex pattern,
          // no edge pattern is output, and no pattern views are involved in the connected component,
          // then use one query block to finish the logic.

          (_accumStatements$accu2 = accumStatements.accumStmts).push.apply(_accumStatements$accu2, patternViewAccumStmts);

          // Get the query block.
          queryBody += _this.getQueryBlock(selectClause, fromClause, whereClause, accumStatements, vertexPatternToBeSelected) + '\n';

          // Output the selected vertex set if needed.
          if (vertexPatternToBeSelected.output) {
            queryBody += "\n  ".concat(_this.getPrintStatement(vertexPatternToBeSelected, "VertexSet_".concat(vertexPatternToBeSelected.id), graph), "\n\n");
          }
        } else {
          var _context61, _context73, _context76, _newAccumStatements$a, _context80;
          // Case 3. If accum and post-accum is not empty, need 2 query blocks.
          // Store all selected vertex aliases and edge aliases with limit to a HeapAccum,
          // then collect the vertices or edges in the HeapAccum to a SetAccum.
          // Add a 2nd query block. Re-generate a FROM clause with the new constraints.
          // Use the SetAccum to constrain corresponding vertex sets and select edge sets,
          // use new vertex blocks to convert SetAccum<vertex> to vertex sets and print them.

          _forEachInstanceProperty__default["default"](_context61 = _filterInstanceProperty__default["default"](vertexPatterns).call(vertexPatterns, function (vertexPattern) {
            return vertexPattern.hasLimit;
          })).call(_context61, function (vertexPattern) {
            var _context65, _context66, _context67, _context68, _context69, _context70, _context71, _context72;
            var tupleFields = ["vertex<".concat(vertexPattern.vertices[0], "> v")];
            var heapOrders = [];
            if (vertexPattern.orderBy.length === 0) {
              tupleFields.push('int f0');
              heapOrders.push('f0 ASC');
            } else {
              var _context62;
              _forEachInstanceProperty__default["default"](_context62 = vertexPattern.orderBy).call(_context62, function (orderBy, i) {
                var _context63, _context64;
                tupleFields.push(_concatInstanceProperty__default["default"](_context63 = "".concat(_this.getExprDataType(orderBy.expression), " f")).call(_context63, i));
                heapOrders.push(_concatInstanceProperty__default["default"](_context64 = "f".concat(i, " ")).call(_context64, orderBy.asc ? 'ASC' : 'DESC'));
              });
            }
            tupleDefs.add(_concatInstanceProperty__default["default"](_context65 = "TYPEDEF TUPLE<".concat(tupleFields.join(', '), "> OrderTuple_")).call(_context65, vertexPattern.id));
            accumulatorsDecl.add(_concatInstanceProperty__default["default"](_context66 = "HeapAccum<OrderTuple_".concat(vertexPattern.id, ">(")).call(_context66, vertexPattern.limit, ", ") + _concatInstanceProperty__default["default"](_context67 = "".concat(heapOrders.join(', '), ") @@OrderHeap_")).call(_context67, vertexPattern.id));
            accumulatorsDecl.add(_concatInstanceProperty__default["default"](_context68 = "SetAccum<vertex<".concat(vertexPattern.vertices[0], ">> @@OrderVertexSet_")).call(_context68, vertexPattern.id));

            // Add one post-accum clause to select the top vertices.
            var orderExprList = _mapInstanceProperty__default["default"](_context69 = vertexPattern.orderBy).call(_context69, function (orderBy) {
              return _this.getOrderByPureExpression(vertexPattern, orderBy);
            });
            if (orderExprList.length === 0) {
              orderExprList.push('1');
            }
            var alias = _this.getPatternComponentAlias(vertexPattern);
            var stmts = accumStatements.postAccumStmts.get(alias) || [];
            stmts.push(_concatInstanceProperty__default["default"](_context70 = _concatInstanceProperty__default["default"](_context71 = _concatInstanceProperty__default["default"](_context72 = "@@OrderHeap_".concat(vertexPattern.id, " += OrderTuple_")).call(_context72, vertexPattern.id, "(")).call(_context71, alias, ", ")).call(_context70, orderExprList.join(', '), ")"));
            accumStatements.postAccumStmts.set(alias, stmts);
          });
          if (accumStatements.accumStmts.length + accumStatements.postAccumStmts.size > 0) {
            // Generate the 1st query block.
            queryBody += _this.getQueryBlock(selectClause, fromClause, whereClause, accumStatements, vertexPatternToBeSelected, true) + '\n';
          }
          _forEachInstanceProperty__default["default"](_context73 = _filterInstanceProperty__default["default"](vertexPatterns).call(vertexPatterns, function (vertexPattern) {
            return vertexPattern.hasLimit;
          })).call(_context73, function (vertexPattern) {
            var _context74, _context75;
            // Convert the HeapAccum into SetAccum.
            queryBody += "  WHILE (@@OrderHeap_".concat(vertexPattern.id, ".size() > 0) DO\n") + _concatInstanceProperty__default["default"](_context74 = "    @@OrderVertexSet_".concat(vertexPattern.id, " += @@OrderHeap_")).call(_context74, vertexPattern.id, ".pop().v;\n") + "  END;\n";
            // Activate the VertexSet from the SetAccum.
            queryBody += _concatInstanceProperty__default["default"](_context75 = "  VertexSet_".concat(vertexPattern.id, " = { @@OrderVertexSet_")).call(_context75, vertexPattern.id, " };\n\n");
            // Add to constrained list.
            constrainedVertexPatterns.add(vertexPattern.id);
          });

          // Re-generate the FROM clause.
          var newFromClause = _this.generateFromClause(queryBlock, graph, constrainedVertexPatterns);

          // Use ACCUM clause to collect the edge sets.
          // Use POST-ACCUM clause to collect the vertex sets.
          var newAccumStatements = {
            accumStmts: [],
            postAccumStmts: new _Map__default["default"]()
          };
          _forEachInstanceProperty__default["default"](_context76 = _filterInstanceProperty__default["default"](edgePatterns).call(edgePatterns, function (edgePattern) {
            return edgePattern.output;
          })).call(_context76, function (edgePattern) {
            var _context77;
            accumulatorsDecl.add("SetAccum<edge> @@FinalEdgeSet_".concat(edgePattern.id));
            newAccumStatements.accumStmts.push(_concatInstanceProperty__default["default"](_context77 = "@@FinalEdgeSet_".concat(edgePattern.id, " += ")).call(_context77, _this.getPatternComponentAlias(edgePattern)));
          });
          _forEachInstanceProperty__default["default"](vertexPatternsToBeCollected).call(vertexPatternsToBeCollected, function (vertexPattern) {
            var _context78, _context79;
            accumulatorsDecl.add(_concatInstanceProperty__default["default"](_context78 = "SetAccum<vertex<".concat(vertexPattern.vertices[0], ">> @@FinalVertexSet_")).call(_context78, vertexPattern.id));
            var alias = _this.getPatternComponentAlias(vertexPattern);
            var stmts = newAccumStatements.postAccumStmts.get(alias) || [];
            stmts.push(_concatInstanceProperty__default["default"](_context79 = "@@FinalVertexSet_".concat(vertexPattern.id, " += ")).call(_context79, alias));
            newAccumStatements.postAccumStmts.set(alias, stmts);
          });
          (_newAccumStatements$a = newAccumStatements.accumStmts).push.apply(_newAccumStatements$a, patternViewAccumStmts);

          // Assemble the 2nd query block.
          queryBody += _this.getQueryBlock(selectClause, newFromClause, whereClause, newAccumStatements, vertexPatternToBeSelected, true) + '\n';

          // Print the edge patterns.
          _forEachInstanceProperty__default["default"](_context80 = _filterInstanceProperty__default["default"](edgePatterns).call(edgePatterns, function (edgePattern) {
            return edgePattern.output;
          })).call(_context80, function (edgePattern) {
            var _context81;
            accumulatorsDecl.add("SetAccum<edge> @@FinalEdgeSet_".concat(edgePattern.id));
            newAccumStatements.accumStmts.push(_concatInstanceProperty__default["default"](_context81 = "@@FinalEdgeSet_".concat(edgePattern.id, " += ")).call(_context81, _this.getPatternComponentAlias(edgePattern)));
            queryBody += "  ".concat(_this.getPrintStatement(edgePattern, "@@FinalEdgeSet_".concat(edgePattern.id), graph), "\n\n");
          });

          // Convert the collected SetAccum<vertex> to vertex sets.
          _forEachInstanceProperty__default["default"](vertexPatternsToBeCollected).call(vertexPatternsToBeCollected, function (vertexPattern) {
            var _context82;
            queryBody += _concatInstanceProperty__default["default"](_context82 = "  VertexSet_".concat(vertexPattern.id, " = { @@FinalVertexSet_")).call(_context82, vertexPattern.id, " };\n");
            // Output the selected vertex set if needed.
            if (vertexPattern.output) {
              queryBody += "  ".concat(_this.getPrintStatement(vertexPattern, "VertexSet_".concat(vertexPattern.id), graph), "\n\n");
            }
          });
        }

        // Pattern view must have at least one SELECT FROM clause.
        if (_this.patternViews.length !== 0 && !_includesInstanceProperty__default["default"](queryBody).call(queryBody, 'SELECT')) {
          var _accumStatements$accu3;
          (_accumStatements$accu3 = accumStatements.accumStmts).push.apply(_accumStatements$accu3, patternViewAccumStmts);

          // Assemble the query block.
          queryBody += _this.getQueryBlock(selectClause, fromClause, whereClause, accumStatements, vertexPatternToBeSelected) + '\n';
        }
        queryBody += patternViewPostProcessingStmts;
      });

      // Assemble the query.
      var result = _concatInstanceProperty__default["default"](_context83 = "CREATE QUERY ".concat(this.name, "(")).call(_context83, _mapInstanceProperty__default["default"](paramsDecl).call(paramsDecl, function (param) {
        return param.toString();
      }).join(', '), ") ") + "FOR GRAPH ".concat(graph.name, " API(\"v2\") SYNTAX v2 {\n") + (this.description ? "/**\n".concat(this.description.replace(new RegExp("/", 'g'), ''), "\n*/\n") : '') + _mapInstanceProperty__default["default"](_context84 = _Array$from__default["default"](tupleDefs)).call(_context84, function (def) {
        return "  ".concat(def, ";\n");
      }).join('') + '\n' + _mapInstanceProperty__default["default"](_context85 = _Array$from__default["default"](accumulatorsDecl)).call(_context85, function (decl) {
        return "  ".concat(decl, ";\n");
      }).join('') + '\n' + queryBody + '}\n';

      // Replace auto-generated components ids with a counter to make the query human-readable.
      return this.makeQueryHumanReadable(result);
    }

    /**
     * Split the pattern into blocks and get their dependencies.
     * block: a connected component of the visual pattern.
     * id2Block: the block id each vertex component and edge component belongs to.
     * For a widget that has input in block 1 and output in block 2,
     * - block 1 is block 2's upper dependency.
     * - block 2 is block 1's lower dependency.
     *
     * @param {{
     *       vertexPatternIds: string[],
     *       edgePatternIds: string[]
     *     }[]} blocks
     * @param {Map<string, number>} id2Block
     * @param {Set<number>[]} upperDependencies
     * @param {Set<number>[]} lowerDependencies
     * @memberof Pattern
     */
  }, {
    key: "splitPatternIntoBlocksAndGetDependencies",
    value: function splitPatternIntoBlocksAndGetDependencies(blocks, id2Block, upperDependencies, lowerDependencies) {
      var _context86,
        _context87,
        _this2 = this,
        _context89;
      // Convert pattern to map<vid -> list<eid>>
      var vid2eidList = new _Map__default["default"]();
      _forEachInstanceProperty__default["default"](_context86 = this.patternEdgeSets).call(_context86, function (pe) {
        var peSrcList = vid2eidList.get(pe.sourcePatternId) || [];
        var peTgtList = vid2eidList.get(pe.targetPatternId) || [];
        peSrcList.push(pe.id);
        if (peTgtList !== peSrcList) {
          peTgtList.push(pe.id);
        }
        vid2eidList.set(pe.sourcePatternId, peSrcList);
        vid2eidList.set(pe.targetPatternId, peTgtList);
      });
      // Holds which vertex and edge patterns have been visited.
      var visited = new _Set__default["default"]();
      // Use BFS to seperate the pattern into blocks.
      _forEachInstanceProperty__default["default"](_context87 = this.patternVertexSets).call(_context87, function (pv) {
        if (!visited.has(pv.id)) {
          var _context88;
          var block = {
            vertexPatternIds: [pv.id],
            edgePatternIds: []
          };
          visited.add(pv.id);
          for (var i = 0; i < block.vertexPatternIds.length; i++) {
            var peList = vid2eidList.get(block.vertexPatternIds[i]) || [];
            _forEachInstanceProperty__default["default"](peList).call(peList, function (peId) {
              var pe = _this2.getPatternEntityById(peId);
              if (!visited.has(pe.sourcePatternId)) {
                visited.add(pe.sourcePatternId);
                block.vertexPatternIds.push(pe.sourcePatternId);
              }
              if (!visited.has(pe.targetPatternId)) {
                visited.add(pe.targetPatternId);
                block.vertexPatternIds.push(pe.targetPatternId);
              }
              if (!visited.has(pe.id)) {
                visited.add(pe.id);
                block.edgePatternIds.push(pe.id);
              }
            });
          }
          blocks.push(block);
          _forEachInstanceProperty__default["default"](_context88 = block.vertexPatternIds).call(_context88, function (pvId) {
            return id2Block.set(pvId, blocks.length - 1);
          });
        }
      });
      // Construct dependency graph between blocks.
      for (var i = 0; i < blocks.length; i++) {
        upperDependencies.push(new _Set__default["default"]());
        lowerDependencies.push(new _Set__default["default"]());
      }
      _forEachInstanceProperty__default["default"](_context89 = this.patternWidgets).call(_context89, function (pw) {
        var _context90;
        _forEachInstanceProperty__default["default"](_context90 = pw.inputPatternIds).call(_context90, function (inputPid) {
          var _context91;
          _forEachInstanceProperty__default["default"](_context91 = pw.outputPatternIds).call(_context91, function (outputPid) {
            upperDependencies[id2Block.get(outputPid)].add(id2Block.get(inputPid));
            lowerDependencies[id2Block.get(inputPid)].add(id2Block.get(outputPid));
          });
        });
      });
    }

    /**
     * Collect parameters in the pattern.
     *
     * @returns {string[]}
     * @memberof Pattern
     */
  }, {
    key: "collectParameters",
    value: function collectParameters() {
      var _context92,
        _context93,
        _this3 = this,
        _context97,
        _context99;
      var paramsDecl = [];

      // Collect the vertex set parameters.
      _forEachInstanceProperty__default["default"](_context92 = this.patternVertexSets).call(_context92, function (patternVertex) {
        var vertexType = patternVertex.vertices[0];
        if (patternVertex.isParam) {
          paramsDecl.push(new patternParam_model.PatternParam(patternVertex.paramName, true, 'vertex', vertexType));
        }
      });

      // Collect the parameters in the expressions in vertex patterns.
      _forEachInstanceProperty__default["default"](_context93 = this.patternVertexSets).call(_context93, function (vertexPattern) {
        var _context94, _context95, _context96;
        _forEachInstanceProperty__default["default"](_context94 = vertexPattern.filters).call(_context94, function (filter) {
          return paramsDecl.push.apply(paramsDecl, _toConsumableArray__default["default"](_this3.collectExprParams(filter)));
        });
        _forEachInstanceProperty__default["default"](_context95 = vertexPattern.aggregations).call(_context95, function (agg) {
          return paramsDecl.push.apply(paramsDecl, _toConsumableArray__default["default"](_this3.collectExprParams(agg.expression)));
        });
        _forEachInstanceProperty__default["default"](_context96 = vertexPattern.orderBy).call(_context96, function (orderBy) {
          return paramsDecl.push.apply(paramsDecl, _toConsumableArray__default["default"](_this3.collectExprParams(orderBy.expression)));
        });
      });

      // Collect the parameters in the expressions in edge patterns.
      _forEachInstanceProperty__default["default"](_context97 = this.patternEdgeSets).call(_context97, function (edgePattern) {
        var _context98;
        _forEachInstanceProperty__default["default"](_context98 = edgePattern.filters).call(_context98, function (filter) {
          return paramsDecl.push.apply(paramsDecl, _toConsumableArray__default["default"](_this3.collectExprParams(filter)));
        });
      });

      // Collect the parameters in the expressions in the pattern views.
      _forEachInstanceProperty__default["default"](_context99 = this.patternViews).call(_context99, function (patternView) {
        var _context100, _context101;
        _forEachInstanceProperty__default["default"](_context100 = patternView.filters).call(_context100, function (filter) {
          return paramsDecl.push.apply(paramsDecl, _toConsumableArray__default["default"](_this3.collectExprParams(filter)));
        });
        // TODO: Collect the parameters in the attachment in the future.
        _forEachInstanceProperty__default["default"](_context101 = patternView.orderBy).call(_context101, function (orderBy) {
          return paramsDecl.push.apply(paramsDecl, _toConsumableArray__default["default"](_this3.collectExprParams(orderBy.expression)));
        });
      });

      // De-duplicate the parameters.
      return lodash.uniqWith(paramsDecl, function (p1, p2) {
        return p1.toString() === p2.toString();
      });
    }
  }, {
    key: "checkVertexComparedWithEdge",
    value: function checkVertexComparedWithEdge(filter, vertexAliases, edgeAliases) {
      if (filter instanceof condition_model.ComparisonCondition) {
        if (expressionValidator.ExpressionValidator.isVertexOrEdge(filter.operands[0].getType()) && expressionValidator.ExpressionValidator.isVertexOrEdge(filter.operands[1].getType())) {
          var alias1 = filter.operands[0].value;
          var alias2 = filter.operands[1].value;
          if (_includesInstanceProperty__default["default"](vertexAliases).call(vertexAliases, alias1.toString()) && _includesInstanceProperty__default["default"](edgeAliases).call(edgeAliases, alias2.toString()) || _includesInstanceProperty__default["default"](edgeAliases).call(edgeAliases, alias1.toString()) && _includesInstanceProperty__default["default"](vertexAliases).call(vertexAliases, alias2.toString())) {
            return {
              error: true,
              message: "".concat(filter.toString(), " is not valid. You can not compare a vertex and an edge.")
            };
          }
        }
      }
      var _iterator = _createForOfIteratorHelper(filter.operands),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var operand = _step.value;
          if (operand instanceof condition_model.BaseCondition) {
            var result = this.checkVertexComparedWithEdge(operand, vertexAliases, edgeAliases);
            if (result.error) {
              return result;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return {
        error: false,
        message: ''
      };
    }

    /**
     * Get a query block giving the clauses.
     *
     * @private
     * @param {string} selectClause
     * @param {string} fromClause
     * @param {string} whereClause
     * @param {{
     *       accumStmts: string[],
     *       postAccumStmts: Map<string, string[]>
     *     }} accumStatements
     * @param {PatternVertexSet} vertexPatternToBeSelected
     * @returns {string}
     * @memberof Pattern
     */
  }, {
    key: "getQueryBlock",
    value: function getQueryBlock(selectClause, fromClause, whereClause, accumStatements, vertexPatternToBeSelected) {
      var _context102,
        _this4 = this;
      var skipOrderByLimit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var accumClause = accumStatements.accumStmts.length > 0 ? "        ACCUM ".concat(accumStatements.accumStmts.join(',\n              '), "\n") : '';
      var postAccumClause = '';
      _forEachInstanceProperty__default["default"](_context102 = accumStatements.postAccumStmts).call(_context102, function (exprList, _) {
        postAccumClause += "        POST-ACCUM ".concat(exprList.join(',\n                   '), "\n");
      });
      var orderByClause = '';
      var limitClause = '';
      if (!skipOrderByLimit) {
        var _context103;
        orderByClause = vertexPatternToBeSelected.orderBy.length > 0 ? '        ORDER BY ' : '';
        orderByClause += _mapInstanceProperty__default["default"](_context103 = vertexPatternToBeSelected.orderBy).call(_context103, function (orderBy) {
          return _this4.getOrderByExpression(vertexPatternToBeSelected, orderBy);
        }).join(',\n              ');
        orderByClause += orderByClause ? '\n' : '';
        limitClause = vertexPatternToBeSelected.hasLimit ? "        LIMIT ".concat(vertexPatternToBeSelected.limit, "\n") : '';
      }
      return selectClause + fromClause + whereClause + accumClause + postAccumClause + orderByClause + limitClause + '        ;\n';
    }

    /**
     * Get an order-by expression.
     *
     * @private
     * @param {PatternVertexSet} vertexPatternToBeSelected
     * @param {PatternOrderBy} orderBy
     * @returns {string}
     * @memberof Pattern
     */
  }, {
    key: "getOrderByExpression",
    value: function getOrderByExpression(vertexPatternToBeSelected, orderBy) {
      var _context104;
      var expression = this.getOrderByPureExpression(vertexPatternToBeSelected, orderBy);
      return _concatInstanceProperty__default["default"](_context104 = "".concat(expression, " ")).call(_context104, orderBy.asc ? 'ASC' : 'DESC');
    }

    /**
     * Get an order-by expression with no ASC|DESC.
     *
     * @private
     * @param {PatternVertexSet} vertexPatternToBeSelected
     * @param {PatternOrderBy} orderBy
     * @returns {string}
     * @memberof Pattern
     */
  }, {
    key: "getOrderByPureExpression",
    value: function getOrderByPureExpression(vertexPatternToBeSelected, orderBy) {
      var _context105;
      var alias = this.getPatternComponentAlias(vertexPatternToBeSelected);
      var expression = this.removeParamParenthesis(orderBy.expression.toString());

      // Replace the accumulator expressions with corresponding accumulators.
      _forEachInstanceProperty__default["default"](_context105 = vertexPatternToBeSelected.aggregations).call(_context105, function (agg) {
        var _context106;
        expression = expression.replace(new RegExp(_concatInstanceProperty__default["default"](_context106 = "(\\W|^)(".concat(alias, "\\.")).call(_context106, agg.name, ")(\\W|$)"), 'g'), function (_, p1, __, p3) {
          var _context107, _context108, _context109, _context110;
          return _concatInstanceProperty__default["default"](_context107 = _concatInstanceProperty__default["default"](_context108 = _concatInstanceProperty__default["default"](_context109 = _concatInstanceProperty__default["default"](_context110 = "".concat(p1)).call(_context110, alias, ".@Agg_")).call(_context109, vertexPatternToBeSelected.id, "_")).call(_context108, agg.name)).call(_context107, p3);
        });
      });
      return expression;
    }

    /**
     * A block only contain one vertex pattern with
     * no filter, aggregation, order-by or limit is ordinary.
     *
     * @private
     * @param {{
     *     vertexPatternIds: string[],
     *     edgePatternIds: string[]
     *   }} block
     * @returns {boolean}
     * @memberof Pattern
     */
  }, {
    key: "isOrdinaryPattern",
    value: function isOrdinaryPattern(block) {
      if (block.vertexPatternIds.length > 1 || block.edgePatternIds.length > 0) {
        return false;
      }
      var vertexPattern = this.getPatternEntityById(block.vertexPatternIds[0]);
      if (vertexPattern.filters.length > 0) {
        return false;
      }
      if (vertexPattern.aggregations.length > 0) {
        return false;
      }
      if (vertexPattern.orderBy.length > 0) {
        return false;
      }
      if (vertexPattern.hasLimit) {
        return false;
      }
      return true;
    }

    /**
     * Get the print statement.
     *
     * @private
     * @param {PatternVertexSet | PatternEdgeSet | PatternView} entity
     * @param {String} entityName
     * @param {Graph} graph
     * @param {String} aliasPrefix
     * @returns {string}
     * @memberof Pattern
     */
  }, {
    key: "getPrintStatement",
    value: function getPrintStatement(entity, entityName, graph, aliasPrefix) {
      var printStatement = "PRINT ".concat(entityName);
      if (entity instanceof patternVertexSet_model.PatternVertexSet) {
        var vertex = graph.getVertex(entity.vertices[0]);
        var aggregations = entity.aggregations;
        if (vertex.attributes.length + aggregations.length === 0) {
          printStatement += "[\"\" as no_attributes]";
        } else {
          var _context111, _context112;
          var items = _concatInstanceProperty__default["default"](_context111 = _mapInstanceProperty__default["default"](_context112 = vertex.attributes).call(_context112, function (attr) {
            var _context113, _context114;
            return _concatInstanceProperty__default["default"](_context113 = _concatInstanceProperty__default["default"](_context114 = "".concat(entityName, ".")).call(_context114, attr.name, " AS ")).call(_context113, attr.name);
          })).call(_context111, _mapInstanceProperty__default["default"](aggregations).call(aggregations, function (agg) {
            var _context115, _context116, _context117;
            return _concatInstanceProperty__default["default"](_context115 = _concatInstanceProperty__default["default"](_context116 = _concatInstanceProperty__default["default"](_context117 = "".concat(entityName, ".@Agg_")).call(_context117, entity.id, "_")).call(_context116, agg.name, " AS ")).call(_context115, agg.name);
          }));
          printStatement += "[\n    ".concat(items.join(',\n    '), "\n  ]");
        }
      }
      if (entity.alias) {
        printStatement += " AS ";
        if (aliasPrefix) {
          printStatement += aliasPrefix + '_';
        }
        printStatement += this.getPatternComponentAlias(entity);
      }
      return printStatement + ";";
    }

    /**
     * Split the pattern into blocks. The order of the blocks follow the widget
     * computation dependencies. If there is circular dependency, the block seperation
     * will fail. The seperation result will be put in the input parameters.
     *
     * @private
     * @param {{
     *     vertexPatternIds: string[],
     *     edgePatternIds: string[]
     *   }[]} blocks splited blocks
     * @param {Map<string, number>} id2Block map from each pattern component's id to block index
     * @returns {boolean}
     * @memberof Pattern
     */
  }, {
    key: "splitPatternIntoBlocks",
    value: function splitPatternIntoBlocks(blocks, id2Block) {
      var tempBlocks = [];
      var tempId2Block = new _Map__default["default"]();
      // upperDependencies[i] stores the block indices of tempBlocks[i]'s upper dependency.
      var upperDependencies = [];
      // lowerDependencies[i] stores the block indices of tempBlocks[i]'s lower dependency.
      var lowerDependencies = [];
      // Use BFS to seperate the pattern into blocks and construct dependency graph between blocks.
      this.splitPatternIntoBlocksAndGetDependencies(tempBlocks, tempId2Block, upperDependencies, lowerDependencies);

      // Use topology sort to detect circular dependency.
      var blockIndices = [];
      _forEachInstanceProperty__default["default"](upperDependencies).call(upperDependencies, function (dep, i) {
        if (dep.size === 0) {
          blockIndices.push(i);
        }
      });
      var _loop = function _loop(i) {
        var _context120;
        _forEachInstanceProperty__default["default"](_context120 = lowerDependencies[blockIndices[i]]).call(_context120, function (bid) {
          upperDependencies[bid]["delete"](blockIndices[i]);
          if (upperDependencies[bid].size === 0) {
            blockIndices.push(bid);
          }
        });
      };
      for (var i = 0; i < blockIndices.length; i++) {
        _loop(i);
      }
      if (blockIndices.length < tempBlocks.length) {
        return false;
      }

      // Put the blocks into the result.
      _forEachInstanceProperty__default["default"](blockIndices).call(blockIndices, function (bid) {
        return blocks.push(tempBlocks[bid]);
      });
      _forEachInstanceProperty__default["default"](blocks).call(blocks, function (block, i) {
        var _context118, _context119;
        _forEachInstanceProperty__default["default"](_context118 = block.vertexPatternIds).call(_context118, function (vid) {
          return id2Block.set(vid, i);
        });
        _forEachInstanceProperty__default["default"](_context119 = block.edgePatternIds).call(_context119, function (eid) {
          return id2Block.set(eid, i);
        });
      });
      return true;
    }

    /**
     * Prepare vertex sets for one query block.
     * 1. If the vertex set has constraint from a parameter, collect the parameter, and generate code:
     *   create ... [QueryName](..., set<vertex<[vertexType]>> [paramName], ...
     *
     *   VertexSet_[patternId] = { [paramName] };
     *
     * 2. If the vertex set has constraint from a fixed id list, generate code:
     *   SetAccum<string> @@VertexSet_[patternId]_idList;
     *   SetAccum<vertex> @@VertexSet_[patternId]_vertexList;
     *
     *   @@VertexSet_[patternId]_idList += [id1];
     *   @@VertexSet_[patternId]_idList += [id2];
     *   ...
     *   @@VertexSet_[patternId]_vertexList = to_vertex_set(@@VertexSet_[patternId]_idList, "[vertexType]");
     *   VertexSet_[patternId] ([vertexType]) = { @@VertexSet_[patternId]_vertexList };
     *
     * 3. If the vertex set is an output of a widget, generate code:
     *    - If it's a Union/Intersect/Subtract widget:
     *      VertexSet_[patternId] = VertexSet_[input_0_patternId] UNION|INTERSECT|MINUS VertexSet_[input_1_patternId];
     *    - If it's a Within widget:
     *      VertexSet_[patternId] = VertexSet_[input_patternId];
     * @private
     * @param {{
     *       vertexPatternIds: string[],
     *       edgePatternIds: string[]
     *     }} queryBlock
     * @param {string[]} accumulatorsDecl
     * @returns {string}
     * @memberof Pattern
     */
  }, {
    key: "prepareVertexSetsInQueryBlock",
    value: function prepareVertexSetsInQueryBlock(queryBlock, accumulatorsDecl, constrainedVertexPatterns) {
      var _context121,
        _this5 = this;
      var resultStmts = [];
      _forEachInstanceProperty__default["default"](_context121 = queryBlock.vertexPatternIds).call(_context121, function (pvId) {
        var _context128;
        var patternVertex = _this5.getPatternEntityById(pvId);
        var vertexType = patternVertex.vertices[0];
        var patternHasParamOrIdConstraints = false;

        // Case 1. the vertex set has constraint from a parameter, collect the parameter:
        if (patternVertex.isParam) {
          var _context122;
          resultStmts.push(_concatInstanceProperty__default["default"](_context122 = "VertexSet_".concat(pvId, " = { ")).call(_context122, patternVertex.paramName, " }"));
          patternHasParamOrIdConstraints = true;
          constrainedVertexPatterns.add(pvId);
        }

        // Case 2. the vertex set has constraint from a fixed id list:
        if (patternVertex.ids.length > 0) {
          var _context123, _context125, _context126, _context127;
          var fixedIdListAccum = "@@VertexSet_".concat(pvId, "_idList");
          var fixedVertexAccum = "@@VertexSet_".concat(pvId, "_vertexList");
          accumulatorsDecl.add("SetAccum<string> ".concat(fixedIdListAccum));
          accumulatorsDecl.add("SetAccum<vertex> ".concat(fixedVertexAccum));
          _forEachInstanceProperty__default["default"](_context123 = patternVertex.ids).call(_context123, function (id) {
            var _context124;
            return resultStmts.push(_concatInstanceProperty__default["default"](_context124 = "".concat(fixedIdListAccum, " += \"")).call(_context124, helperFunctions.HelperFunctions.escapeQuote(id), "\""));
          });
          resultStmts.push("".concat(fixedVertexAccum, " = ") + _concatInstanceProperty__default["default"](_context125 = "to_vertex_set(".concat(fixedIdListAccum, ", \"")).call(_context125, vertexType, "\")"));
          resultStmts.push(_concatInstanceProperty__default["default"](_context126 = _concatInstanceProperty__default["default"](_context127 = "VertexSet_".concat(pvId, " (")).call(_context127, vertexType, ") = { ")).call(_context126, fixedVertexAccum, " }"));
          patternHasParamOrIdConstraints = true;
          constrainedVertexPatterns.add(pvId);
        }

        // Case 3. the vertex set is an output of a widget:
        var widget = _findInstanceProperty__default["default"](_context128 = _this5.patternWidgets).call(_context128, function (pw) {
          var _context129;
          return _includesInstanceProperty__default["default"](_context129 = pw.outputPatternIds).call(_context129, pvId);
        });
        if (widget) {
          var rhsCode = '';
          switch (widget.type) {
            case patternWidget_model.VertexSetOperation.Intersect:
              {
                var _context130, _context131;
                rhsCode = _mapInstanceProperty__default["default"](_context130 = widget.inputPatternIds).call(_context130, function (pid) {
                  return "VertexSet_".concat(pid);
                }).join(' INTERSECT ');
                resultStmts.push("VertexSet_".concat(pvId, " = ") + (patternHasParamOrIdConstraints ? _concatInstanceProperty__default["default"](_context131 = "VertexSet_".concat(pvId, " INTERSECT (")).call(_context131, rhsCode, ")") : rhsCode));
                constrainedVertexPatterns.add(pvId);
                break;
              }
            case patternWidget_model.VertexSetOperation.Union:
              {
                var _context132, _context133;
                rhsCode = _mapInstanceProperty__default["default"](_context132 = widget.inputPatternIds).call(_context132, function (pid) {
                  return "VertexSet_".concat(pid);
                }).join(' UNION ');
                resultStmts.push("VertexSet_".concat(pvId, " = ") + (patternHasParamOrIdConstraints ? _concatInstanceProperty__default["default"](_context133 = "VertexSet_".concat(pvId, " INTERSECT (")).call(_context133, rhsCode, ")") : rhsCode));
                constrainedVertexPatterns.add(pvId);
                break;
              }
            case patternWidget_model.VertexSetOperation.Subtract:
              {
                var _context134, _context135;
                rhsCode = _mapInstanceProperty__default["default"](_context134 = widget.inputPatternIds).call(_context134, function (pid) {
                  return "VertexSet_".concat(pid);
                }).join(' MINUS ');
                resultStmts.push("VertexSet_".concat(pvId, " = ") + (patternHasParamOrIdConstraints ? _concatInstanceProperty__default["default"](_context135 = "VertexSet_".concat(pvId, " INTERSECT (")).call(_context135, rhsCode, ")") : rhsCode));
                constrainedVertexPatterns.add(pvId);
                break;
              }
            case patternWidget_model.VertexSetOperation.Within:
              {
                var withinWidgetInputId = widget.inputPatternIds[0];
                if (_this5.checkVertexPatternHasNoFromClause(queryBlock, patternVertex)) {
                  // if no FROM clause will be generated, a new VertexSet assignment is necessary.
                  rhsCode = "VertexSet_".concat(withinWidgetInputId);
                }
                if (patternHasParamOrIdConstraints) {
                  var _context136;
                  rhsCode = _concatInstanceProperty__default["default"](_context136 = "VertexSet_".concat(pvId, " INTERSECT VertexSet_")).call(_context136, withinWidgetInputId);
                }
                if (rhsCode) {
                  var _context137;
                  resultStmts.push(_concatInstanceProperty__default["default"](_context137 = "VertexSet_".concat(pvId, " = ")).call(_context137, rhsCode));
                  constrainedVertexPatterns.add(pvId);
                }
                break;
              }
            default:
              {
                // TODO: Support other widget types.
                throw new graphStudioError_model.GraphStudioError("Not supported widget type ".concat(widget.type, "."));
              }
          }
        }
      });
      return _mapInstanceProperty__default["default"](resultStmts).call(resultStmts, function (stmt) {
        return "  ".concat(stmt, ";\n");
      }).join('');
    }

    /**
     * Check if the GSQL code generation will not generate a FROM clause for a given vertex pattern.
     *
     * @private
     * @param {PatternVertexSet} vertexPattern
     * @returns {boolean}
     * @memberof Pattern
     */
  }, {
    key: "checkVertexPatternHasNoFromClause",
    value: function checkVertexPatternHasNoFromClause(queryBlock, vertexPattern) {
      return !vertexPattern.isParam && vertexPattern.filters.length === 0 && vertexPattern.aggregations.length === 0 && vertexPattern.orderBy.length === 0 && !vertexPattern.hasLimit && queryBlock.vertexPatternIds.length === 1 && queryBlock.edgePatternIds.length === 0;
    }

    /**
     * Generate the FROM clause of a given query block.
     *
     * @private
     * @param {{
     *       vertexPatternIds: string[],
     *       edgePatternIds: string[]
     *     }} queryBlock
     * @param {Graph} graph
     * @returns {string}
     * @param {Set<string>} constrainedVertexPatterns
     * @memberof Pattern
     */
  }, {
    key: "generateFromClause",
    value: function generateFromClause(queryBlock, graph, constrainedVertexPatterns) {
      var _context138,
        _this6 = this;
      if (queryBlock.vertexPatternIds.length === 1 && queryBlock.edgePatternIds.length === 0) {
        return "        FROM ".concat(this.codeToReferToOneVertexPatternInFromClause(queryBlock.vertexPatternIds[0], constrainedVertexPatterns), "\n");
      }
      var edgePatternsCode = _mapInstanceProperty__default["default"](_context138 = queryBlock.edgePatternIds).call(_context138, function (peId) {
        return _this6.generateOneEdgePatternInFromClause(_this6.getPatternEntityById(peId), graph, constrainedVertexPatterns);
      });
      return "        FROM ".concat(edgePatternsCode.join(',\n             '), "\n");
    }

    /**
     * Generate one edge pattern code in FROM clause.
     *
     * @private
     * @param {PatternEdgeSet} patternEdgeSet
     * @param {Graph} graph
     * @param {Set<string>} constrainedVertexPatterns
     * @returns {string}
     * @memberof Pattern
     */
  }, {
    key: "generateOneEdgePatternInFromClause",
    value: function generateOneEdgePatternInFromClause(patternEdgeSet, graph, constrainedVertexPatterns) {
      var _context139, _context140;
      var result = '';

      // Source vertex pattern.
      result += this.codeToReferToOneVertexPatternInFromClause(patternEdgeSet.sourcePatternId, constrainedVertexPatterns);

      // Edge pattern.
      var edgeType = patternEdgeSet.edges[0];
      result += _concatInstanceProperty__default["default"](_context139 = " -(".concat(edgeType + (graph.getEdge(edgeType).directed ? '>' : ''))).call(_context139, patternEdgeSet.repeatAtLeast === 1 && patternEdgeSet.repeatAtMost === 1 ? ":".concat(this.getPatternComponentAlias(patternEdgeSet)) : _concatInstanceProperty__default["default"](_context140 = "*".concat(patternEdgeSet.repeatAtLeast, "..")).call(_context140, patternEdgeSet.repeatAtMost), ")- ");

      // Target vertex pattern.
      result += this.codeToReferToOneVertexPatternInFromClause(patternEdgeSet.targetPatternId, constrainedVertexPatterns);
      return result;
    }

    /**
     * Code in FROM clause to refer to a vertex pattern.
     *
     * @private
     * @param {string} patternId
     * @param {Set<string>} constrainedVertexPatterns
     * @returns {string}
     * @memberof Pattern
     */
  }, {
    key: "codeToReferToOneVertexPatternInFromClause",
    value: function codeToReferToOneVertexPatternInFromClause(vertexSetId, constrainedVertexPatterns) {
      var _context141;
      var vertexPattern = this.getPatternEntityById(vertexSetId);
      var fromConstrain = '';
      if (!constrainedVertexPatterns.has(vertexSetId)) {
        // If the vertex set is not prepared,
        // we should either refer to its within widget parent or its vertex type.
        var parentVertexSetId = this.findWithinWidgetInput(vertexSetId);
        fromConstrain = parentVertexSetId ? "VertexSet_".concat(parentVertexSetId) : vertexPattern.vertices[0];
      } else {
        fromConstrain = "VertexSet_".concat(vertexSetId);
      }
      return _concatInstanceProperty__default["default"](_context141 = "".concat(fromConstrain, ":")).call(_context141, this.getPatternComponentAlias(vertexPattern));
    }

    /**
     * If the vertex set of the given id is an output of a Within widget,
     * return the input vertex pattern id of the widget.
     *
     * @private
     * @param {string} vertexSetId
     * @returns {string}
     * @memberof Pattern
     */
  }, {
    key: "findWithinWidgetInput",
    value: function findWithinWidgetInput(vertexSetId) {
      var _context142;
      var widget = _findInstanceProperty__default["default"](_context142 = this.patternWidgets).call(_context142, function (pw) {
        var _context143;
        return _includesInstanceProperty__default["default"](_context143 = pw.outputPatternIds).call(_context143, vertexSetId);
      });
      if (widget && widget.type === patternWidget_model.VertexSetOperation.Within) {
        vertexSetId = widget.inputPatternIds[0];
        return vertexSetId;
      }
      return '';
    }

    /**
     * Get vertex or edge pattern alias.
     *
     * @private
     * @param {PatternEntity} component
     * @returns {string}
     * @memberof Pattern
     */
  }, {
    key: "getPatternComponentAlias",
    value: function getPatternComponentAlias(component) {
      var _context144;
      return component.alias ? component.alias : _concatInstanceProperty__default["default"](_context144 = "".concat(buildAliasSchema.aliasSchemaAffix, "_")).call(_context144, component.id);
    }

    /**
     * Generate the WHERE clause. The clause will contain the disjunction of all filter expressions
     * on all vertex patterns and edge patterns of the query block.
     *
     * @private
     * @param {{
     *       vertexPatternIds: string[],
     *       edgePatternIds: string[]
     *     }} queryBlock
     * @returns {string}
     * @memberof Pattern
     */
  }, {
    key: "generateWhereClause",
    value: function generateWhereClause(queryBlock) {
      var _context145,
        _context146,
        _context147,
        _this7 = this,
        _context148;
      var filterExpressions = [];

      // Filters on vertex patterns and edge patterns.
      _forEachInstanceProperty__default["default"](_context145 = _concatInstanceProperty__default["default"](_context146 = _mapInstanceProperty__default["default"](_context147 = queryBlock.vertexPatternIds).call(_context147, function (pvId) {
        return _this7.getPatternEntityById(pvId);
      })).call(_context146, _mapInstanceProperty__default["default"](_context148 = queryBlock.edgePatternIds).call(_context148, function (peId) {
        return _this7.getPatternEntityById(peId);
      }))).call(_context145, function (pv) {
        var _context149;
        return filterExpressions.push.apply(filterExpressions, _toConsumableArray__default["default"](_mapInstanceProperty__default["default"](_context149 = pv.filters).call(_context149, function (filter) {
          return _this7.removeParamParenthesis(filter.toString());
        })));
      });

      // return filterExpressions;
      return filterExpressions.length === 0 ? '' : "        WHERE ".concat(filterExpressions.join(' AND \n              '), "\n");
    }

    /**
     * Generate the ACCUM clauses and POST-ACCUM statements of each vertex pattern in the query block.
     *
     * @private
     * @param {{
     *       vertexPatternIds: string[],
     *       edgePatternIds: string[]
     *     }} queryBlock
     * @param {string[]} accumulatorsDecl
     * @returns {{
     *     accumStmts: string[],
     *     postAccumStmts: Map<string, string[]>
     *   }}
     * @memberof Pattern
     */
  }, {
    key: "generateAccumStatements",
    value: function generateAccumStatements(queryBlock, accumulatorsDecl) {
      var _context150,
        _this8 = this;
      var accumStmts = [];
      var postAccumStmts = new _Map__default["default"]();
      _forEachInstanceProperty__default["default"](_context150 = queryBlock.vertexPatternIds).call(_context150, function (pvId) {
        var _context151;
        var vertexPattern = _this8.getPatternEntityById(pvId);
        var alias = _this8.getPatternComponentAlias(vertexPattern);
        _forEachInstanceProperty__default["default"](_context151 = vertexPattern.aggregations).call(_context151, function (aggregation) {
          var _context152, _context157, _context158;
          var aggAccumName = _concatInstanceProperty__default["default"](_context152 = "@Agg_".concat(pvId, "_")).call(_context152, aggregation.name);
          // aggIsAnExpression represents if the aggregation is an expression.
          var aggIsAnExpression = aggregation.expression instanceof expression_model.ArithmeticExpression;
          var dfsHelper = {
            // hasSeenAggregationFunction represents if there is at least one aggregation function.
            hasSeenAggregationFunction: false,
            // funcAccumId generates unique accumulator names in the recursion
            // to translate functions in the aggregation to GSQL code.
            aggregationFunctionAccumId: 0,
            // accumulatorsDecl and accumStmts collect SumAccum declarations and statements
            // for the case when the aggregation involves attributes of vertex or edge.
            accumulatorsDecl: new _Set__default["default"](),
            accumStmts: []
          };

          // Recursively generate GSQL code.
          var code = _this8.generateAccumStatementsHelper(aggregation.expression, alias, aggAccumName, aggIsAnExpression, dfsHelper, accumulatorsDecl, accumStmts, postAccumStmts);

          // Post-processing
          if (dfsHelper.hasSeenAggregationFunction) {
            if (aggIsAnExpression) {
              var _context153, _context154, _context155, _context156;
              // If the aggregation is an expression and it contains at least one aggregation function,
              // 1. for each attribute of vertex or edge, use a SumAccum in the ACCUM clause
              //    to collect its values and refer to this SumAccum instead in the POST-ACCUM clause.
              // 2. use an additional SumAccum<double> in the POST-ACCUM clause to collect the value
              //    of the expression.

              _forEachInstanceProperty__default["default"](_context153 = dfsHelper.accumulatorsDecl).call(_context153, function (accumDecl) {
                accumulatorsDecl.add(accumDecl);
              });
              _forEachInstanceProperty__default["default"](_context154 = dfsHelper.accumStmts).call(_context154, function (accumStmt) {
                accumStmts.push(accumStmt);
              });
              accumulatorsDecl.add("SumAccum<double> ".concat(aggAccumName));
              var stmts = postAccumStmts.get(alias) || [];
              stmts.push(_concatInstanceProperty__default["default"](_context155 = _concatInstanceProperty__default["default"](_context156 = "".concat(alias, ".")).call(_context156, aggAccumName, " = ")).call(_context155, code));
              postAccumStmts.set(alias, stmts);
            } // otherwise, do nothing because the GSQL code has been generated during the recursion.
          } else {
            var _context159, _context160;
            // For aggregations with only vertex, edge or atom
            switch (aggregation.expression.getType()) {
              case dataType_enum.DataType.VertexOrEdge:
                var setAccumType = 'edge';
                if (_findInstanceProperty__default["default"](_context157 = _this8.patternVertexSets).call(_context157, function (pv) {
                  return pv.alias === aggregation.expression.value;
                })) {
                  setAccumType = 'vertex';
                }
                accumulatorsDecl.add(_concatInstanceProperty__default["default"](_context158 = "SetAccum<".concat(setAccumType, "> ")).call(_context158, aggAccumName));
                break;
              case dataType_enum.DataType.String:
                accumulatorsDecl.add("SumAccum<string> ".concat(aggAccumName));
                break;
              case dataType_enum.DataType.Int:
                accumulatorsDecl.add("SumAccum<int> ".concat(aggAccumName));
                break;
              case dataType_enum.DataType.Real:
                accumulatorsDecl.add("SumAccum<double> ".concat(aggAccumName));
                break;
              case dataType_enum.DataType.Bool:
                accumulatorsDecl.add("OrAccum ".concat(aggAccumName));
                break;
              case dataType_enum.DataType.Datetime:
                accumulatorsDecl.add("SetAccum<datetime> ".concat(aggAccumName));
                break;
            }
            accumStmts.push(_concatInstanceProperty__default["default"](_context159 = _concatInstanceProperty__default["default"](_context160 = "".concat(alias, ".")).call(_context160, aggAccumName, " = ")).call(_context159, _this8.removeParamParenthesis(aggregation.expression.toString())));
          }
        });
      });
      return {
        accumStmts: accumStmts,
        postAccumStmts: postAccumStmts
      };
    }

    /**
     * Use recursion to help generate the ACCUM clauses and POST-ACCUM statements of
     * one vertex pattern in the query block.
     *
     * @private
     * @param {(Atom | BaseExpression)} expression
     * @param {string} alias
     * @param {string} aggAccumName
     * @param {boolean} aggIsAnExpression
     * @param {{
      *       hasSeenAggregationFunction: boolean,
      *       aggregationFunctionAccumId: number
      *     }} dfsHelper
     * @param {Set<string>} accumulatorsDecl
     * @param {string[]} accumStmts
     * @param {Map<string, string[]>} postAccumStmts
     *
     * @returns {string}
     * @memberof Pattern
     */
  }, {
    key: "generateAccumStatementsHelper",
    value: function generateAccumStatementsHelper(expression, alias, aggAccumName, aggIsAnExpression, dfsHelper, accumulatorsDecl, accumStmts, postAccumStmts) {
      if (expression instanceof expression_model.ArithmeticExpression) {
        var _context161, _context162;
        var leftStmt = this.generateAccumStatementsHelper(expression.operands[0], alias, aggAccumName, aggIsAnExpression, dfsHelper, accumulatorsDecl, accumStmts, postAccumStmts);
        var operator = expression.operator;
        var rightStmt = this.generateAccumStatementsHelper(expression.operands[1], alias, aggAccumName, aggIsAnExpression, dfsHelper, accumulatorsDecl, accumStmts, postAccumStmts);
        return _concatInstanceProperty__default["default"](_context161 = _concatInstanceProperty__default["default"](_context162 = "(".concat(leftStmt, " ")).call(_context162, operator, " ")).call(_context161, rightStmt, ")");
      } else if (expression instanceof expression_model.FunctionExpression) {
        var _context185;
        dfsHelper.hasSeenAggregationFunction = true;
        if (aggIsAnExpression) {
          var _context163;
          aggAccumName = _concatInstanceProperty__default["default"](_context163 = "".concat(aggAccumName, "_")).call(_context163, dfsHelper.aggregationFunctionAccumId);
          dfsHelper.aggregationFunctionAccumId++;
        }
        switch (expression.operator) {
          case operators_enum.FunctionType.Sum:
            {
              var _context164, _context165;
              accumulatorsDecl.add("SumAccum<double> ".concat(aggAccumName));
              accumStmts.push(_concatInstanceProperty__default["default"](_context164 = _concatInstanceProperty__default["default"](_context165 = "".concat(alias, ".")).call(_context165, aggAccumName, " += ")).call(_context164, this.removeParamParenthesis(expression.operands[0].toString())));
              break;
            }
          case operators_enum.FunctionType.Max:
            {
              var _context166, _context167;
              accumulatorsDecl.add("MaxAccum<double> ".concat(aggAccumName));
              accumStmts.push(_concatInstanceProperty__default["default"](_context166 = _concatInstanceProperty__default["default"](_context167 = "".concat(alias, ".")).call(_context167, aggAccumName, " += ")).call(_context166, this.removeParamParenthesis(expression.operands[0].toString())));
              break;
            }
          case operators_enum.FunctionType.Min:
            {
              var _context168, _context169;
              accumulatorsDecl.add("MinAccum<double> ".concat(aggAccumName));
              accumStmts.push(_concatInstanceProperty__default["default"](_context168 = _concatInstanceProperty__default["default"](_context169 = "".concat(alias, ".")).call(_context169, aggAccumName, " += ")).call(_context168, this.removeParamParenthesis(expression.operands[0].toString())));
              break;
            }
          case operators_enum.FunctionType.Avg:
            {
              var _context170, _context171;
              accumulatorsDecl.add("AvgAccum ".concat(aggAccumName));
              accumStmts.push(_concatInstanceProperty__default["default"](_context170 = _concatInstanceProperty__default["default"](_context171 = "".concat(alias, ".")).call(_context171, aggAccumName, " += ")).call(_context170, this.removeParamParenthesis(expression.operands[0].toString())));
              break;
            }
          case operators_enum.FunctionType.Count:
            {
              var _context172;
              accumulatorsDecl.add("SumAccum<int> ".concat(aggAccumName));
              accumStmts.push(_concatInstanceProperty__default["default"](_context172 = "".concat(alias, ".")).call(_context172, aggAccumName, " += 1"));
              break;
            }
          case operators_enum.FunctionType.DistinctCount:
            {
              var _context173, _context174, _context175, _context176, _context177, _context178;
              accumulatorsDecl.add(_concatInstanceProperty__default["default"](_context173 = "SetAccum<".concat(this.getExprDataType(expression.operands[0]), "> ")).call(_context173, aggAccumName, "_set"));
              accumStmts.push(_concatInstanceProperty__default["default"](_context174 = _concatInstanceProperty__default["default"](_context175 = "".concat(alias, ".")).call(_context175, aggAccumName, "_set += ")).call(_context174, this.removeParamParenthesis(expression.operands[0].toString())));
              accumulatorsDecl.add("SumAccum<int> ".concat(aggAccumName));
              var stmts = postAccumStmts.get(alias) || [];
              stmts.push(_concatInstanceProperty__default["default"](_context176 = _concatInstanceProperty__default["default"](_context177 = _concatInstanceProperty__default["default"](_context178 = "".concat(alias, ".")).call(_context178, aggAccumName, " = ")).call(_context177, alias, ".")).call(_context176, aggAccumName, "_set.size()"));
              postAccumStmts.set(alias, stmts);
              break;
            }
          case operators_enum.FunctionType.Collect:
            {
              var _context179, _context180, _context181;
              accumulatorsDecl.add(_concatInstanceProperty__default["default"](_context179 = "ListAccum<".concat(this.getExprDataType(expression.operands[0]), "> ")).call(_context179, aggAccumName));
              accumStmts.push(_concatInstanceProperty__default["default"](_context180 = _concatInstanceProperty__default["default"](_context181 = "".concat(alias, ".")).call(_context181, aggAccumName, " += ")).call(_context180, this.removeParamParenthesis(expression.operands[0].toString())));
              break;
            }
          case operators_enum.FunctionType.DistinctCollect:
            {
              var _context182, _context183, _context184;
              accumulatorsDecl.add(_concatInstanceProperty__default["default"](_context182 = "SetAccum<".concat(this.getExprDataType(expression.operands[0]), "> ")).call(_context182, aggAccumName));
              accumStmts.push(_concatInstanceProperty__default["default"](_context183 = _concatInstanceProperty__default["default"](_context184 = "".concat(alias, ".")).call(_context184, aggAccumName, " += ")).call(_context183, this.removeParamParenthesis(expression.operands[0].toString())));
              break;
            }
        }
        // If the aggregation function is at the top level of the aggregation,
        // its GSQL code will be generated during the recursion,
        // so no need to return other information to do post-processing.
        return aggIsAnExpression ? _concatInstanceProperty__default["default"](_context185 = "".concat(alias, ".")).call(_context185, aggAccumName) : '';
      } else if (expression instanceof atom_model.AttrVariableWithAlias) {
        var _context186, _context187, _context188, _context189, _context190;
        // For an aggregation whose top level is an expression with functions inside,
        // it needs a POST-ACCUM clause; However, POST-ACCUM cannot refer to any attributes
        // on another vertex or edge; Therefore, in this case we use an additional SumAccum
        // to collect those attributes and refer to the SumAccum instead in the POST-ACCUM clause.

        // If the attribute is at the top level of the aggregation,
        // its GSQL code will be generated in the post-processing.
        if (!aggIsAnExpression) {
          return '';
        }
        var sumAccumType = '';
        switch (expression.getType()) {
          case dataType_enum.DataType.Int:
            {
              sumAccumType = 'int';
              break;
            }
          case dataType_enum.DataType.Real:
            {
              sumAccumType = 'double';
              break;
            }
          // TODO: Support other data types for attribute on another alias in the future.
        }
        // If the attribute type is boolean, string or datetime,
        // which means the attribute must be at the top level of the aggregation,
        // its GSQL code will be generated in the post-processing.
        if (sumAccumType === '') {
          return '';
        }
        aggAccumName = _concatInstanceProperty__default["default"](_context186 = "".concat(aggAccumName, "_")).call(_context186, dfsHelper.aggregationFunctionAccumId);
        dfsHelper.aggregationFunctionAccumId++;
        dfsHelper.accumulatorsDecl.add(_concatInstanceProperty__default["default"](_context187 = "SumAccum<".concat(sumAccumType, "> ")).call(_context187, aggAccumName));
        dfsHelper.accumStmts.push(_concatInstanceProperty__default["default"](_context188 = _concatInstanceProperty__default["default"](_context189 = "".concat(alias, ".")).call(_context189, aggAccumName, " = ")).call(_context188, this.removeParamParenthesis(expression.toString())));
        return _concatInstanceProperty__default["default"](_context190 = "".concat(alias, ".")).call(_context190, aggAccumName);
      } else {
        return this.removeParamParenthesis(expression.toString());
      }
    }

    /**
     * Get GSQL data type based on expression data type.
     *
     * @private
     * @param {(Atom | BaseExpression)} expression
     * @returns {string}
     * @memberof Pattern
     */
  }, {
    key: "getExprDataType",
    value: function getExprDataType(expression) {
      if (expression instanceof atom_model.AliasReference) {
        var _context191;
        var alias = expression.value;
        if (_findInstanceProperty__default["default"](_context191 = this.patternVertexSets).call(_context191, function (pv) {
          return pv.alias === alias;
        })) {
          return 'vertex';
        }
        return 'edge';
      }
      var dataType;
      if (expression instanceof expression_model.BaseExpression) {
        dataType = expression.getType();
      } else {
        dataType = expression.valueType;
      }
      switch (dataType) {
        case dataType_enum.DataType.String:
          {
            return 'string';
          }
        case dataType_enum.DataType.Int:
          {
            return 'int';
          }
        case dataType_enum.DataType.Real:
          {
            return 'double';
          }
        case dataType_enum.DataType.Bool:
          {
            return 'bool';
          }
        case dataType_enum.DataType.Datetime:
          {
            return 'datetime';
          }
      }
    }

    /**
     * Collect parameters from one expression.
     *
     * @private
     * @param {(BaseCondition | BaseExpression | Atom)} model
     * @returns {PatternParam[]}
     * @memberof Pattern
     */
  }, {
    key: "collectExprParams",
    value: function collectExprParams(model) {
      if (model instanceof atom_model.Atom) {
        return model instanceof atom_model.BaseParam ? [this.getParam(model)] : [];
      }
      var params = [];
      if (model.operands) {
        for (var i = 0; i < model.operands.length; i++) {
          params.push.apply(params, _toConsumableArray__default["default"](this.collectExprParams(model.operands[i])));
        }
      }
      return params;
    }

    /**
     * Get the parameter of one atom level expression.
     *
     * @private
     * @param {BaseParam} model
     * @returns {PatternParam}
     * @memberof Pattern
     */
  }, {
    key: "getParam",
    value: function getParam(model) {
      switch (true) {
        case model instanceof atom_model.IntParam:
          {
            return new patternParam_model.PatternParam(model.value, false, 'int');
          }
        case model instanceof atom_model.RealParam:
          {
            return new patternParam_model.PatternParam(model.value, false, 'double');
          }
        case model instanceof atom_model.StringParam:
          {
            return new patternParam_model.PatternParam(model.value, false, 'string');
          }
        case model instanceof atom_model.DatetimeParam:
          {
            return new patternParam_model.PatternParam(model.value, false, 'datetime');
          }
        case model instanceof atom_model.BoolParam:
          {
            return new patternParam_model.PatternParam(model.value, false, 'bool');
          }
      }
    }

    /**
     * Conduct semantic check on the pattern given a graph schema.
     *
     * @param {Graph} graph
     * @returns {PatternSemanticCheckResult}
     * @memberof Pattern
     */
  }, {
    key: "semanticCheck",
    value: function semanticCheck(graph) {
      var _context192,
        _context193,
        _context194,
        _context195,
        _this9 = this,
        _context199,
        _context207,
        _context208,
        _context209,
        _context210,
        _context211;
      var success = true;
      var errors = [];

      // All pattern entities.
      var patternEntities = _concatInstanceProperty__default["default"](_context192 = _concatInstanceProperty__default["default"](_context193 = _concatInstanceProperty__default["default"](_context194 = this.patternVertexSets).call(_context194, this.patternEdgeSets)).call(_context193, this.patternWidgets)).call(_context192, this.patternViews);

      // 0. If the pattern is empty, should report empty pattern error directly. No other errors.
      if (patternEntities.length === 0) {
        return {
          success: false,
          errors: [{
            message: 'The pattern is empty.',
            involvedPatternEntities: []
          }]
        };
      }

      // Check if the pattern matches the schema:
      // 1. No vertex pattern should refer to non-exist vertex type(s) in schema.
      var notExistVertexTypeToPatternIdList = new _Map__default["default"]();
      var _iterator2 = _createForOfIteratorHelper(this.patternVertexSets),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _context218;
          var patternVertexSet = _step2.value;
          var vertexType = patternVertexSet.vertices[0];
          if (!_includesInstanceProperty__default["default"](_context218 = graph.getAllVertexTypes()).call(_context218, vertexType)) {
            success = false;
            var patternIdList = notExistVertexTypeToPatternIdList.get(vertexType) || [];
            patternIdList.push(patternVertexSet.id);
            notExistVertexTypeToPatternIdList.set(vertexType, patternIdList);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      _forEachInstanceProperty__default["default"](notExistVertexTypeToPatternIdList).call(notExistVertexTypeToPatternIdList, function (patternIdList, vType) {
        errors.push({
          message: "Vertex type ".concat(vType, " does not exist in the graph schema."),
          involvedPatternEntities: patternIdList
        });
      });

      // 2. No edge pattern should refer to non-exist edge type(s) in schema.
      var notExistEdgeTypeToPatternIdList = new _Map__default["default"]();
      var _iterator3 = _createForOfIteratorHelper(this.patternEdgeSets),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _context219;
          var patternEdgeSet = _step3.value;
          var edgeType = patternEdgeSet.edges[0];
          if (!_includesInstanceProperty__default["default"](_context219 = graph.getAllEdgeTypes()).call(_context219, edgeType)) {
            success = false;
            var _patternIdList = notExistEdgeTypeToPatternIdList.get(edgeType) || [];
            _patternIdList.push(patternEdgeSet.id);
            notExistEdgeTypeToPatternIdList.set(edgeType, _patternIdList);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      _forEachInstanceProperty__default["default"](notExistEdgeTypeToPatternIdList).call(notExistEdgeTypeToPatternIdList, function (patternIdList, vType) {
        errors.push({
          message: "Edge type ".concat(vType, " does not exist in the graph schema."),
          involvedPatternEntities: patternIdList
        });
      });

      // 3. Check if the pattern's expressions are valid.
      success = this.semanticCheckExpressions(graph, errors) && success;

      // 4. Check if any widget has errors.
      // For now, the only check needed is all input and output vertex patterns are of the same type.
      var widgetsWithDifferentInputAndOutputTypes = [];
      _forEachInstanceProperty__default["default"](_context195 = this.patternWidgets).call(_context195, function (widget) {
        var _context196, _context197, _context198;
        var inAndOut = _mapInstanceProperty__default["default"](_context196 = _concatInstanceProperty__default["default"](_context197 = widget.inputPatternIds).call(_context197, widget.outputPatternIds)).call(_context196, function (pId) {
          return _this9.getPatternEntityById(pId).vertices[0];
        });
        var isValid = _reduceInstanceProperty__default["default"](_context198 = _mapInstanceProperty__default["default"](inAndOut).call(inAndOut, function (type) {
          return type === inAndOut[0];
        })).call(_context198, function (a, b) {
          return a && b;
        }, true);
        if (!isValid) {
          success = false;
          widgetsWithDifferentInputAndOutputTypes.push(widget.id);
        }
      });
      if (widgetsWithDifferentInputAndOutputTypes.length > 0) {
        errors.push({
          message: "All the input and output vertex patterns of a widget must have same vertex type.",
          involvedPatternEntities: widgetsWithDifferentInputAndOutputTypes
        });
      }

      // 5. Check if edge type exists between source and target vertex pattern.
      var allTriplets = triplet.Triplet.getAllTriplets(graph);
      var notExistEdgeTriplet = new _Map__default["default"]();
      _forEachInstanceProperty__default["default"](_context199 = this.patternEdgeSets).call(_context199, function (pe) {
        var _context200;
        var edgeType = pe.edges[0];
        if (_includesInstanceProperty__default["default"](_context200 = graph.getAllEdgeTypes()).call(_context200, edgeType)) {
          var sourceVertexType = _this9.getPatternEntityById(pe.sourcePatternId).vertices[0];
          var targetVertexType = _this9.getPatternEntityById(pe.targetPatternId).vertices[0];
          var compliedTriplets = triplet.Triplet.refineByEdge(triplet.Triplet.refineBySource(triplet.Triplet.refineByTarget(allTriplets, [targetVertexType]), [sourceVertexType]), [edgeType]);
          if (compliedTriplets.length === 0) {
            var _context201, _context202, _context203;
            success = false;
            var tripletRep = _concatInstanceProperty__default["default"](_context201 = _concatInstanceProperty__default["default"](_context202 = "".concat(sourceVertexType, "#")).call(_context202, targetVertexType, "#")).call(_context201, edgeType);
            notExistEdgeTriplet.set(tripletRep, _concatInstanceProperty__default["default"](_context203 = notExistEdgeTriplet.get(tripletRep) || []).call(_context203, [pe.id]));
          }
        }
      });
      _forEachInstanceProperty__default["default"](notExistEdgeTriplet).call(notExistEdgeTriplet, function (idList, triplet) {
        var _context204;
        var types = triplet.split('#');
        errors.push({
          message: "Edge type ".concat(types[2], " doesn't exist ") + _concatInstanceProperty__default["default"](_context204 = "from vertex type ".concat(types[0], " to vertex type ")).call(_context204, types[1], "."),
          involvedPatternEntities: idList
        });
      });
      var queryBlocks = [];
      var id2Block = new _Map__default["default"]();
      var upperDependencies = [];
      var lowerDependencies = [];
      this.splitPatternIntoBlocksAndGetDependencies(queryBlocks, id2Block, upperDependencies, lowerDependencies);
      // 6. There should be no circle dependencies among the connected components.
      var _loop2 = function _loop2() {
        var checkCircle = _this9.patternBlocksContainsCircle(i, [i], lowerDependencies);
        if (checkCircle.hasCircle) {
          var _context220, _context221;
          success = false;
          var widgets = _mapInstanceProperty__default["default"](_context220 = _filterInstanceProperty__default["default"](_context221 = _this9.patternWidgets).call(_context221, function (widget) {
            var _context222, _context224;
            return _filterInstanceProperty__default["default"](_context222 = widget.inputPatternIds).call(_context222, function (entity) {
              var _context223;
              return _includesInstanceProperty__default["default"](_context223 = checkCircle.circle).call(_context223, id2Block.get(entity));
            }).length > 0 && _filterInstanceProperty__default["default"](_context224 = widget.outputPatternIds).call(_context224, function (entity) {
              var _context225;
              return _includesInstanceProperty__default["default"](_context225 = checkCircle.circle).call(_context225, id2Block.get(entity));
            }).length > 0;
          })).call(_context220, function (widget) {
            return widget.id;
          });
          errors.push({
            message: 'Widget patterns cause circular dependencies among vertex patterns.',
            involvedPatternEntities: widgets
          });
          return 1; // break
        }
      };
      for (var i = 0; i < queryBlocks.length; i++) {
        if (_loop2()) break;
      }

      // 7. Check if the pattern's pattern views are valid.
      success = this.semanticCheckPatternViews(id2Block, errors) && success;

      // 8. No parameters should have same name but different data types.
      var params = this.collectParameters();
      var paramInCompatible = new _Map__default["default"]();
      _forEachInstanceProperty__default["default"](params).call(params, function (param, i) {
        var _context205, _context206;
        // Parameters cannot have same name as vertex or edge type.
        if (_includesInstanceProperty__default["default"](_context205 = graph.getAllVertexTypes()).call(_context205, param.paramName)) {
          success = false;
          errors.push({
            message: "Parameter cannot be named as ".concat(param.paramName, " because it is a vertex type."),
            involvedPatternEntities: []
          });
        }
        if (_includesInstanceProperty__default["default"](_context206 = graph.getAllEdgeTypes()).call(_context206, param.paramName)) {
          success = false;
          errors.push({
            message: "Parameter cannot be named as ".concat(param.paramName, " because it is an edge type."),
            involvedPatternEntities: []
          });
        }
        // Same parameter cannot appear as different parameter types.
        for (var j = 0; j < i; j++) {
          if (!param.isCompatible(params[j])) {
            var paramWithSameName = paramInCompatible.get(param.paramName) || new _Set__default["default"]();
            paramWithSameName.add(param.getTypeDescription());
            paramWithSameName.add(params[j].getTypeDescription());
            paramInCompatible.set(param.paramName, paramWithSameName);
          }
        }
      });
      if (paramInCompatible.size > 0) {
        success = false;
        _forEachInstanceProperty__default["default"](paramInCompatible).call(paramInCompatible, function (descList, paramName) {
          return errors.push({
            message: "Parameter ".concat(paramName, " cannot be ") + "".concat(helperFunctions.HelperFunctions.joinStrAsPara(_Array$from__default["default"](descList)), " at the same time."),
            involvedPatternEntities: []
          });
        });
      }

      // 9. Parameter name shouldn't be duplicated with aliases.
      var paramNames = new _Set__default["default"]();
      _forEachInstanceProperty__default["default"](params).call(params, function (param) {
        return paramNames.add(param.paramName);
      });
      var aliases = _concatInstanceProperty__default["default"](_context207 = _concatInstanceProperty__default["default"](_context208 = _mapInstanceProperty__default["default"](_context209 = this.patternVertexSets).call(_context209, function (vertexSet) {
        return vertexSet.alias;
      })).call(_context208, _mapInstanceProperty__default["default"](_context210 = this.patternEdgeSets).call(_context210, function (edgeSet) {
        return edgeSet.alias;
      }))).call(_context207, _mapInstanceProperty__default["default"](_context211 = this.patternViews).call(_context211, function (patternView) {
        return patternView.alias;
      }));
      _forEachInstanceProperty__default["default"](paramNames).call(paramNames, function (pName) {
        if (_includesInstanceProperty__default["default"](aliases).call(aliases, pName)) {
          success = false;
          errors.push({
            message: "Parameter name ".concat(pName, " duplicates with a vertex pattern, edge pattern or pattern view name."),
            involvedPatternEntities: []
          });
        }
      });

      // 9. Vertex should not be compared with edge.
      _forEachInstanceProperty__default["default"](queryBlocks).call(queryBlocks, function (block) {
        var _context212, _context213, _context214, _context216;
        var vertexAliases = _mapInstanceProperty__default["default"](_context212 = block.vertexPatternIds).call(_context212, function (vid) {
          return _this9.getPatternComponentAlias(_this9.findComponentById(vid));
        });
        var edgeAliases = _mapInstanceProperty__default["default"](_context213 = block.edgePatternIds).call(_context213, function (eid) {
          return _this9.getPatternComponentAlias(_this9.findComponentById(eid));
        });
        _forEachInstanceProperty__default["default"](_context214 = block.vertexPatternIds).call(_context214, function (vid) {
          var _context215;
          _forEachInstanceProperty__default["default"](_context215 = _this9.findComponentById(vid).filters).call(_context215, function (filter) {
            var check = _this9.checkVertexComparedWithEdge(filter, vertexAliases, edgeAliases);
            if (check.error) {
              success = false;
              errors.push({
                message: check.message,
                involvedPatternEntities: [vid]
              });
            }
          });
        });
        _forEachInstanceProperty__default["default"](_context216 = block.edgePatternIds).call(_context216, function (eid) {
          var _context217;
          _forEachInstanceProperty__default["default"](_context217 = _this9.findComponentById(eid).filters).call(_context217, function (filter) {
            var check = _this9.checkVertexComparedWithEdge(filter, vertexAliases, edgeAliases);
            if (check.error) {
              success = false;
              errors.push({
                message: check.message,
                involvedPatternEntities: [eid]
              });
            }
          });
        });
      });

      // 10. Should output something.
      var patternEntitiesToBeOutput = _filterInstanceProperty__default["default"](patternEntities).call(patternEntities, function (entity) {
        return entity.output;
      });
      if (patternEntities.length > 0 && patternEntitiesToBeOutput.length === 0) {
        success = false;
        errors.push({
          message: 'Should output something in the pattern.',
          involvedPatternEntities: []
        });
      }
      return {
        success: success,
        errors: errors
      };
    }

    /**
     * Check if pattern blocks contains circle dependencies caused by widget connections.
     *
     * @private
     * @param {number} head
     * @param {number[]} touchedBlockIds
     * @param {Set<number>[]} outLinks
     * @returns {{
     *     hasCircle: boolean,
     *     circle: number[]
     *   }}
     * @memberof Pattern
     */
  }, {
    key: "patternBlocksContainsCircle",
    value: function patternBlocksContainsCircle(head, touchedBlockIds, outLinks) {
      var _context226;
      // Check if the traversal path contains a circle.
      var indexOfHead = _indexOfInstanceProperty__default["default"](_context226 = _sliceInstanceProperty__default["default"](touchedBlockIds).call(touchedBlockIds, 0, touchedBlockIds.length - 1)).call(_context226, head);
      if (indexOfHead !== -1) {
        return {
          hasCircle: true,
          circle: _sliceInstanceProperty__default["default"](touchedBlockIds).call(touchedBlockIds, indexOfHead + 1)
        };
      }
      var _iterator4 = _createForOfIteratorHelper(outLinks[head]),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var nextId = _step4.value;
          touchedBlockIds.push(nextId);
          var checkCircle = this.patternBlocksContainsCircle(nextId, touchedBlockIds, outLinks);
          if (checkCircle.hasCircle) {
            return checkCircle;
          }
          _spliceInstanceProperty__default["default"](touchedBlockIds).call(touchedBlockIds, touchedBlockIds.length - 2);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return {
        hasCircle: false,
        circle: []
      };
    }

    /**
     * Given a tree root, refine the compliance vertex and edge types supported at each pattern
     * vertex and edge pattern from bottom to root. At each tree node, the compliance types will be
     * the intersection of recursive refinement result backtraced from each child tree node. The
     * refinement result vertex types will be annotated onto each vertex pattern.
     * Pattern: A - B - C
     *              |
     *              D - E - F
     *                  |
     *                  G
     * Starting from B as root, you recursively refine following DFS order of the tree, and
     * do intersection at each parent node. The refinement order will follow:
     * A, G, F, E, D, C, B
     *
     * @private
     * @param {PatternVertexSet} parent
     * @param {PatternVertexSet} current
     * @param {Graph} graph
     * @param {SchemaTriplet[]} allTriplets
     * @param {Map<string, string[]>} typeAnnonation
     * @param {Set<string>} visited
     * @memberof Pattern
     */
  }, {
    key: "bottomUpIntersectComplianceTypes",
    value: function bottomUpIntersectComplianceTypes(parent, current, graph, allTriplets, typeAnnonation, visited) {
      var _context227,
        _this10 = this;
      visited.add(current.id);

      // Get the supported vertex types of current vertex pattern.
      var complianceVertexTypes = current.vertices;
      if (complianceVertexTypes.length === 0) {
        complianceVertexTypes = graph.getAllVertexTypes();
      }
      // Get all schema triplets going out from and going in to current vertex pattern compliance vertex types.
      var outgoingTriplets = triplet.Triplet.refineBySource(allTriplets, complianceVertexTypes);
      var incomingTriplets = triplet.Triplet.refineByTarget(allTriplets, complianceVertexTypes);

      // Recursive call each child vertex pattern which is not the parent.
      _forEachInstanceProperty__default["default"](_context227 = this.patternEdgeSets).call(_context227, function (patternEdgeSet) {
        var patternEdgeTypes = patternEdgeSet.edges;
        if (patternEdgeTypes.length === 0) {
          patternEdgeTypes = graph.getAllEdgeTypes();
        }
        if (patternEdgeSet.sourcePatternId === current.id && patternEdgeSet.targetPatternId !== parent.id) {
          var targetId = patternEdgeSet.targetPatternId;
          if (targetId && !visited.has(targetId)) {
            var _context228;
            var childPattern = _filterInstanceProperty__default["default"](_context228 = _this10.patternVertexSets).call(_context228, function (pv) {
              return pv.id === targetId;
            })[0];
            // Recursively refine child vertex pattern.
            _this10.bottomUpIntersectComplianceTypes(current, childPattern, graph, allTriplets, typeAnnonation, visited);
            // Refine outgoingTriplets by edge pattern edge types and target vertex pattern types.
            var complianceTriplets = triplet.Triplet.refineByTarget(triplet.Triplet.refineByEdge(outgoingTriplets, patternEdgeTypes), typeAnnonation.get(targetId));
            // Refine complianceVertexTypes.
            complianceVertexTypes = lodash.intersectionWith(complianceVertexTypes, triplet.Triplet.getSourceTypes(complianceTriplets), lodash.isEqual);
          }
        } else if (patternEdgeSet.targetPatternId === current.id && patternEdgeSet.sourcePatternId !== parent.id) {
          var sourceId = patternEdgeSet.sourcePatternId;
          if (sourceId && !visited.has(sourceId)) {
            var _context229;
            var _childPattern = _filterInstanceProperty__default["default"](_context229 = _this10.patternVertexSets).call(_context229, function (pv) {
              return pv.id === sourceId;
            })[0];
            // Recursively refine child vertex pattern.
            _this10.bottomUpIntersectComplianceTypes(current, _childPattern, graph, allTriplets, typeAnnonation, visited);
            // Refine incomingTriplets by edge pattern edge types and source vertex pattern vertex types.
            var _complianceTriplets = triplet.Triplet.refineBySource(triplet.Triplet.refineByEdge(incomingTriplets, patternEdgeTypes), typeAnnonation.get(sourceId));
            // Refine complianceVertexTypes.
            complianceVertexTypes = lodash.intersectionWith(complianceVertexTypes, triplet.Triplet.getTargetTypes(_complianceTriplets), lodash.isEqual);
          }
        }
      });

      // Update typeAnnotation map.
      typeAnnonation.set(current.id, complianceVertexTypes);
    }

    /**
     * Given a tree root, refine the compliance vertex and edge types supported at each pattern
     * vertex and edge pattern from root to leaves. At each tree node, the compliance vertex types
     * will be the intersection of top refinement result pushed down to current tree node, and the
     * compliance edge types will be refined by the edge pattern. The refinement result vertex types
     * and edge types will be annotated onto each vertex pattern and edge pattern.
     * Pattern: A - B - C
     *              |
     *              D - E - F
     *                  |
     *                  G
     * Starting from B as root, you recursively refine following DFS order of the tree, and
     * do intersection at each child node. The refinement order will follow:
     * B, A, D, E, G, F, C
     * @private
     * @param {PatternVertexSet} parent
     * @param {PatternVertexSet} current
     * @param {Graph} graph
     * @param {SchemaTriplet[]} allTriplets
     * @param {Map<string, string[]>} typeAnnonation
     * @param {Set<string>} visited
     * @memberof Pattern
     */
  }, {
    key: "topDownIntersectComplianceTypes",
    value: function topDownIntersectComplianceTypes(parent, current, graph, allTriplets, typeAnnonation, visited) {
      var _context230,
        _this11 = this;
      visited.add(current.id);

      // Get the supported vertex types of current vertex pattern.
      var complianceVertexTypes = typeAnnonation.get(current.id);
      var outgoingTriplets = triplet.Triplet.refineBySource(allTriplets, complianceVertexTypes);
      var incomingTriplets = triplet.Triplet.refineByTarget(allTriplets, complianceVertexTypes);

      // Recursive call each child vertex pattern which is not the parent.
      _forEachInstanceProperty__default["default"](_context230 = this.patternEdgeSets).call(_context230, function (patternEdgeSet) {
        var patternEdgeTypes = patternEdgeSet.edges;
        if (patternEdgeTypes.length === 0) {
          patternEdgeTypes = graph.getAllEdgeTypes();
        }
        if (patternEdgeSet.sourcePatternId === current.id && patternEdgeSet.targetPatternId !== parent.id) {
          var targetId = patternEdgeSet.targetPatternId;
          if (targetId && !visited.has(targetId)) {
            var _context231;
            var childPattern = _filterInstanceProperty__default["default"](_context231 = _this11.patternVertexSets).call(_context231, function (pv) {
              return pv.id === targetId;
            })[0];
            // Refine outgoingTriplets by edge pattern edge types and target vertex pattern vertex types.
            var complianceTriplets = triplet.Triplet.refineByTarget(triplet.Triplet.refineByEdge(outgoingTriplets, patternEdgeTypes), typeAnnonation.get(targetId));
            // Refine edge pattern edge types.
            typeAnnonation.set(patternEdgeSet.id, triplet.Triplet.getEdgeTypes(complianceTriplets));
            // Refine target vertex pattern vertex types.
            typeAnnonation.set(targetId, triplet.Triplet.getTargetTypes(complianceTriplets));
            // Recursively refine child vertex pattern.
            _this11.topDownIntersectComplianceTypes(current, childPattern, graph, allTriplets, typeAnnonation, visited);
          }
        } else if (patternEdgeSet.targetPatternId === current.id && patternEdgeSet.sourcePatternId !== parent.id) {
          var sourceId = patternEdgeSet.sourcePatternId;
          if (sourceId && !visited.has(sourceId)) {
            var _context232;
            var _childPattern2 = _filterInstanceProperty__default["default"](_context232 = _this11.patternVertexSets).call(_context232, function (pv) {
              return pv.id === sourceId;
            })[0];
            // Refine incomingTriplets by edge pattern edge types and source vertex pattern vertex types.
            var _complianceTriplets2 = triplet.Triplet.refineBySource(triplet.Triplet.refineByEdge(incomingTriplets, patternEdgeTypes), typeAnnonation.get(sourceId));
            // Refine edge pattern edge types.
            typeAnnonation.set(patternEdgeSet.id, triplet.Triplet.getEdgeTypes(_complianceTriplets2));
            // Refine source vertex pattern vertex types.
            typeAnnonation.set(sourceId, triplet.Triplet.getSourceTypes(_complianceTriplets2));
            // Recursively refine child vertex pattern.
            _this11.topDownIntersectComplianceTypes(current, _childPattern2, graph, allTriplets, typeAnnonation, visited);
          }
        }
      });
    }

    /**
     * Find pattern entity by id.
     *
     * @private
     * @param {string} id
     * @returns {PatternEntity}
     * @memberof Pattern
     */
  }, {
    key: "getPatternEntityById",
    value: function getPatternEntityById(id) {
      var _context233, _context234, _context235;
      var entities = _concatInstanceProperty__default["default"](_context233 = _concatInstanceProperty__default["default"](_context234 = _concatInstanceProperty__default["default"](_context235 = this.patternVertexSets).call(_context235, this.patternEdgeSets)).call(_context234, this.patternWidgets)).call(_context233, this.patternViews);
      return _filterInstanceProperty__default["default"](entities).call(entities, function (entity) {
        return entity.id === id;
      })[0];
    }

    /**
     * Semantic check on all of the expressions of the pattern.
     *
     * @private
     * @param {Graph} graph
     * @param {PatternSemanticError[]} errors
     * @returns {boolean}
     * @memberof Pattern
     */
  }, {
    key: "semanticCheckExpressions",
    value: function semanticCheckExpressions(graph, errors) {
      var _context236,
        _this12 = this,
        _context241,
        _context255;
      var success = true;

      // 1. Check edge pattern filters.
      _forEachInstanceProperty__default["default"](_context236 = this.patternEdgeSets).call(_context236, function (edgePattern) {
        var _context237, _context238;
        var filterHasNoUnsupportedFeatures = _reduceInstanceProperty__default["default"](_context237 = _mapInstanceProperty__default["default"](_context238 = edgePattern.filters).call(_context238, function (filter) {
          return _this12.checkOperandIsValid(filter, [], config.getFilterFormConfig());
        })).call(_context237, function (a, b) {
          return a && b;
        }, true);
        if (!filterHasNoUnsupportedFeatures) {
          success = false;
          errors.push({
            message: 'One edge pattern contains unsupported features in its filters. ' + 'Did you import a solution from a higher version of GraphStudio?',
            involvedPatternEntities: [edgePattern.id]
          });
        } else {
          var _context239, _context240;
          var filterHasNoSemanticErrors = _reduceInstanceProperty__default["default"](_context239 = _mapInstanceProperty__default["default"](_context240 = edgePattern.filters).call(_context240, function (filter) {
            return filter.semanticCheck().success;
          })).call(_context239, function (a, b) {
            return a && b;
          }, true);
          if (!filterHasNoSemanticErrors) {
            success = false;
            errors.push({
              message: 'One edge pattern has errors in its filters.',
              involvedPatternEntities: [edgePattern.id]
            });
          }
        }
      });

      // 2. Check vertex pattern filters, aggregations and order-bys.
      _forEachInstanceProperty__default["default"](_context241 = this.patternVertexSets).call(_context241, function (vertexPattern) {
        var _context242, _context243, _context246, _context247, _context251, _context252;
        var unsupportedFeatureSection = [];
        var errorSection = [];
        var filterHasNoUnsupportedFeatures = _reduceInstanceProperty__default["default"](_context242 = _mapInstanceProperty__default["default"](_context243 = vertexPattern.filters).call(_context243, function (filter) {
          return _this12.checkOperandIsValid(filter, [], config.getFilterFormConfig());
        })).call(_context242, function (a, b) {
          return a && b;
        }, true);
        if (!filterHasNoUnsupportedFeatures) {
          unsupportedFeatureSection.push('filters');
        } else {
          var _context244, _context245;
          var filterHasNoSemanticErrors = _reduceInstanceProperty__default["default"](_context244 = _mapInstanceProperty__default["default"](_context245 = vertexPattern.filters).call(_context245, function (filter) {
            return filter.semanticCheck().success;
          })).call(_context244, function (a, b) {
            return a && b;
          }, true);
          if (!filterHasNoSemanticErrors) {
            errorSection.push('filters');
          }
        }
        var aggHasNoUnsupportedFeatures = _reduceInstanceProperty__default["default"](_context246 = _mapInstanceProperty__default["default"](_context247 = vertexPattern.aggregations).call(_context247, function (agg) {
          return _this12.checkOperandIsValid(agg.expression, [], config.getAggregationFormConfig());
        })).call(_context246, function (a, b) {
          return a && b;
        }, true);
        if (!aggHasNoUnsupportedFeatures) {
          unsupportedFeatureSection.push('attachments');
        } else {
          var _context248, _context249, _context250;
          var aggNames = _mapInstanceProperty__default["default"](_context248 = vertexPattern.aggregations).call(_context248, function (agg) {
            return agg.name;
          });
          var aggHasNoSemanticErrors = _reduceInstanceProperty__default["default"](_context249 = _mapInstanceProperty__default["default"](_context250 = vertexPattern.aggregations).call(_context250, function (agg) {
            return agg.expression.semanticCheck().success && agg.checkAggregationName(aggNames, graph).success;
          })).call(_context249, function (a, b) {
            return a && b;
          }, true);
          if (!aggHasNoSemanticErrors) {
            errorSection.push('attachments');
          }
        }
        var orderByHasNoUnsupportedFeatures = _reduceInstanceProperty__default["default"](_context251 = _mapInstanceProperty__default["default"](_context252 = vertexPattern.orderBy).call(_context252, function (orderBy) {
          return _this12.checkOperandIsValid(orderBy.expression, [], config.getOrderByFormConfig());
        })).call(_context251, function (a, b) {
          return a && b;
        }, true);
        if (!orderByHasNoUnsupportedFeatures) {
          unsupportedFeatureSection.push('order-by expressions');
        } else {
          var _context253, _context254;
          var orderByHasNoSemanticErrors = _reduceInstanceProperty__default["default"](_context253 = _mapInstanceProperty__default["default"](_context254 = vertexPattern.orderBy).call(_context254, function (orderBy) {
            return orderBy.expression.semanticCheck().success;
          })).call(_context253, function (a, b) {
            return a && b;
          }, true);
          if (!orderByHasNoSemanticErrors) {
            errorSection.push('order-by expressions');
          }
        }
        if (unsupportedFeatureSection.length > 0) {
          success = false;
          errors.push({
            message: "One vertex pattern contains unsupported features in its " + "".concat(helperFunctions.HelperFunctions.joinStrAsPara(unsupportedFeatureSection), ". ") + "Did you import a solution from a higher version of GraphStudio?",
            involvedPatternEntities: [vertexPattern.id]
          });
        }
        if (errorSection.length > 0) {
          success = false;
          errors.push({
            message: "One vertex pattern has errors in its ".concat(helperFunctions.HelperFunctions.joinStrAsPara(errorSection), "."),
            involvedPatternEntities: [vertexPattern.id]
          });
        }
      });

      // 3. Check pattern view order-bys.
      _forEachInstanceProperty__default["default"](_context255 = this.patternViews).call(_context255, function (patternView) {
        var _context256, _context257;
        var unsupportedFeatureSection = [];
        var errorSection = [];
        var orderByHasNoUnsupportedFeatures = _reduceInstanceProperty__default["default"](_context256 = _mapInstanceProperty__default["default"](_context257 = patternView.orderBy).call(_context257, function (orderBy) {
          return _this12.checkOperandIsValid(orderBy.expression, [], config.getOrderByFormConfig());
        })).call(_context256, function (a, b) {
          return a && b;
        }, true);
        if (!orderByHasNoUnsupportedFeatures) {
          unsupportedFeatureSection.push('order-by expressions');
        } else {
          var _context258, _context259;
          var orderByHasNoSemanticErrors = _reduceInstanceProperty__default["default"](_context258 = _mapInstanceProperty__default["default"](_context259 = patternView.orderBy).call(_context259, function (orderBy) {
            return orderBy.expression.semanticCheck().success;
          })).call(_context258, function (a, b) {
            return a && b;
          }, true);
          if (!orderByHasNoSemanticErrors) {
            errorSection.push('order-by expressions');
          }
        }
        if (unsupportedFeatureSection.length > 0) {
          success = false;
          errors.push({
            message: "One pattern view contains unsupported features in its " + "".concat(helperFunctions.HelperFunctions.joinStrAsPara(unsupportedFeatureSection), ". ") + "Did you import a solution from a higher version of GraphStudio?",
            involvedPatternEntities: [patternView.id]
          });
        }
        if (errorSection.length > 0) {
          success = false;
          errors.push({
            message: "One pattern view has errors in its ".concat(helperFunctions.HelperFunctions.joinStrAsPara(errorSection), "."),
            involvedPatternEntities: [patternView.id]
          });
        }
      });
      return success;
    }

    /**
     * Semantic check on all of patten views of the pattern.
     *
     * @private
     * @param {Map<string, number>} id2Block
     * @param {PatternSemanticError[]} errors
     *
     * @returns {boolean}
     * @memberof Pattern
     */
  }, {
    key: "semanticCheckPatternViews",
    value: function semanticCheckPatternViews(id2Block, errors) {
      var _context260, _context262, _context264, _context269;
      var success = true;

      // 1. Check if the pattern views do not overlap with each other,
      // namely, no vertex patterns should belong to more than one pattern view.
      // TODO: We may loose this constraint in the future.

      // <key = vertex set id, value = id of the pattern view that the vertex set belongs to>
      var vertexSetId2PatternViewIds = new _Map__default["default"]();
      _forEachInstanceProperty__default["default"](_context260 = this.patternViews).call(_context260, function (patternView) {
        var _context261;
        if (!success) {
          return;
        }
        _forEachInstanceProperty__default["default"](_context261 = patternView.vertexSetIds).call(_context261, function (vertexSetId) {
          var patternViewIds = vertexSetId2PatternViewIds.get(vertexSetId) || new _Set__default["default"]();
          patternViewIds.add(patternView.id);
          if (patternViewIds.size > 1) {
            success = false;
            errors.push({
              message: "We currently do not support pattern views overlap with each other.",
              involvedPatternEntities: _Array$from__default["default"](_valuesInstanceProperty__default["default"](patternViewIds).call(patternViewIds))
            });
            return;
          }
          vertexSetId2PatternViewIds.set(vertexSetId, patternViewIds);
        });
      });

      // 2. Check if the pattern views do not across more than one connected component,
      // namely, no pattern views should contain vertex patterns that belong to multiple blocks.
      _forEachInstanceProperty__default["default"](_context262 = this.patternViews).call(_context262, function (patternView) {
        var _context263;
        if (!success) {
          return;
        }
        var blockIndex = -1;
        _forEachInstanceProperty__default["default"](_context263 = patternView.vertexSetIds).call(_context263, function (vertexSetIdInView) {
          if (blockIndex === -1) {
            blockIndex = id2Block.get(vertexSetIdInView);
          } else if (blockIndex !== id2Block.get(vertexSetIdInView)) {
            success = false;
            errors.push({
              message: "We currently do not support one pattern view across different connected components.",
              involvedPatternEntities: [patternView.id]
            });
            return;
          }
        });
      });

      // 3. Check pattern view filters and order-bys.
      // TODO: Support semantic check on attachment in the future.
      _forEachInstanceProperty__default["default"](_context264 = this.patternViews).call(_context264, function (patternView) {
        var _context265, _context266, _context267, _context268;
        var filterHasNoErrors = _reduceInstanceProperty__default["default"](_context265 = _mapInstanceProperty__default["default"](_context266 = patternView.filters).call(_context266, function (filter) {
          return filter.semanticCheck().success;
        })).call(_context265, function (a, b) {
          return a && b;
        }, true);
        var orderByHasNoErrors = _reduceInstanceProperty__default["default"](_context267 = _mapInstanceProperty__default["default"](_context268 = patternView.orderBy).call(_context268, function (orderBy) {
          return orderBy.expression.semanticCheck().success;
        })).call(_context267, function (a, b) {
          return a && b;
        }, true);
        var errorSection = [];
        if (!filterHasNoErrors) {
          errorSection.push('filters');
        }
        if (!orderByHasNoErrors) {
          errorSection.push('order-by expressions');
        }
        if (errorSection.length > 0) {
          success = false;
          errors.push({
            message: "The pattern view has errors in its ".concat(helperFunctions.HelperFunctions.joinStrAsPara(errorSection), "."),
            involvedPatternEntities: [patternView.id]
          });
        }
      });

      // 4. Check if each pattern view has an alias.
      _forEachInstanceProperty__default["default"](_context269 = this.patternViews).call(_context269, function (patternView) {
        if (!patternView.alias) {
          success = false;
          errors.push({
            message: "Each pattern view should have its name.",
            involvedPatternEntities: [patternView.id]
          });
        }
      });
      return success;
    }

    /**
     * Remove parameter parenthesis from the expression.
     *
     * @private
     * @param {string} expr
     * @returns {string}
     * @memberof Pattern
     */
  }, {
    key: "removeParamParenthesis",
    value: function removeParamParenthesis(expr) {
      return expr.replace(new RegExp("{{", 'g'), '').replace(new RegExp("}}", 'g'), '');
    }

    /**
     * Replace auto-generated components ids with a counter to make the query human-readable.
     *
     * @private
     * @param {string} query
     * @returns {string}
     * @memberof Pattern
     */
  }, {
    key: "makeQueryHumanReadable",
    value: function makeQueryHumanReadable(query) {
      var _context270, _context271, _context272, _context273, _context274, _context275, _context276;
      var queryPOIs = ['alias_schema', 'Agg', 'EdgeSet', 'FinalVertexSet', 'FinalEdgeSet', 'OrderHeap', 'OrderTuple', 'OrderVertexSet', 'VertexSet'];
      var componentIDs = _concatInstanceProperty__default["default"](_context270 = _concatInstanceProperty__default["default"](_context271 = _concatInstanceProperty__default["default"](_context272 = _mapInstanceProperty__default["default"](_context273 = this.patternVertexSets).call(_context273, function (v) {
        return v.id;
      })).call(_context272, _mapInstanceProperty__default["default"](_context274 = this.patternEdgeSets).call(_context274, function (e) {
        return e.id;
      }))).call(_context271, _mapInstanceProperty__default["default"](_context275 = this.patternWidgets).call(_context275, function (w) {
        return w.id;
      }))).call(_context270, _mapInstanceProperty__default["default"](_context276 = this.patternViews).call(_context276, function (pv) {
        return pv.id;
      }));
      var counter = 0;
      _forEachInstanceProperty__default["default"](componentIDs).call(componentIDs, function (id) {
        // Find next safe name.
        counter++;
        while (_findInstanceProperty__default["default"](queryPOIs).call(queryPOIs, function (poi) {
          var _context277, _context278;
          return query.search(new RegExp(_concatInstanceProperty__default["default"](_context277 = "\\b".concat(poi, "_")).call(_context277, counter, "_"), 'g')) > -1 || query.search(new RegExp(_concatInstanceProperty__default["default"](_context278 = "\\b".concat(poi, "_")).call(_context278, counter, "\\b"), 'g')) > -1;
        })) {
          counter++;
        }

        // Replace the id with counter.
        query = query.replace(new RegExp("_".concat(id, "\\b"), 'g'), "_".concat(counter)).replace(new RegExp("_".concat(id, "_"), 'g'), "_".concat(counter, "_"));
      });
      return query;
    }

    /**
     * Recursively check if the operand of an atom or each operand's operator in a (nested) condition/expression
     * corresponds to a valid operand type allowed by the given config and the given operands types for each
     * (nested) condition/expression.
     *
     * @param {(Atom | BaseExpression | BaseCondition)} operand
     * @param {string[]} operandsTypes
     * @param {ExpressionFormConfig} config
     * @return {boolean}
     * @memberof Pattern
     */
  }, {
    key: "checkOperandIsValid",
    value: function checkOperandIsValid(operand, operandsTypes, config) {
      // Construct a list of valid operand types by filtering out the operand types that are not allowed in
      // the given config or in the operandsTypes.
      var validOperandsTypes;
      if (operand instanceof atom_model.Atom) {
        validOperandsTypes = defaultOptionsList.defaultOptList;
      } else if (operand instanceof expression_model.BaseExpression) {
        validOperandsTypes = defaultOptionsList.defaultExprList;
      } else if (operand instanceof condition_model.BaseCondition) {
        validOperandsTypes = defaultOptionsList.defaultCondList;
      }
      validOperandsTypes = _filterInstanceProperty__default["default"](validOperandsTypes).call(validOperandsTypes, function (validOperandType) {
        var _context279;
        return _includesInstanceProperty__default["default"](_context279 = config.supportOptions).call(_context279, validOperandType);
      });
      if (operandsTypes.length > 0) {
        validOperandsTypes = _filterInstanceProperty__default["default"](validOperandsTypes).call(validOperandsTypes, function (validOperandType) {
          return _includesInstanceProperty__default["default"](operandsTypes).call(operandsTypes, validOperandType);
        });
      }
      if (_includesInstanceProperty__default["default"](validOperandsTypes).call(validOperandsTypes, 'Function') && config.supportFunctions && config.supportFunctions.length > 0) {
        var funcList = _filterInstanceProperty__default["default"](defaultOptionsList.defaultFuncList).call(defaultOptionsList.defaultFuncList, function (functionType) {
          var _context280;
          return _includesInstanceProperty__default["default"](_context280 = config.supportFunctions).call(_context280, functionType);
        });
        validOperandsTypes = _concatInstanceProperty__default["default"](validOperandsTypes).call(validOperandsTypes, funcList);
      }

      // Check if the operand type of an atom or the operand's operator in a condition/expression corresponds
      // to a valid operand type.
      var operandType = operand.toJson().type;
      if (operand instanceof atom_model.Atom) {
        return _includesInstanceProperty__default["default"](validOperandsTypes).call(validOperandsTypes, operandType);
      } else if (operand instanceof expression_model.BaseExpression) {
        if (operandType !== 'NullExpression' && !_includesInstanceProperty__default["default"](validOperandsTypes).call(validOperandsTypes, operand.operator)) {
          return false;
        }
      } else if (operand instanceof condition_model.BaseCondition) {
        if (operandType !== 'NullCondition' && !_includesInstanceProperty__default["default"](validOperandsTypes).call(validOperandsTypes, operand.operator)) {
          return false;
        }
      }
      for (var i = 0; i < operand.operands.length; i++) {
        if (!this.checkOperandIsValid(operand.operands[i], operand.operandsTypes[i], config)) {
          return false;
        }
      }
      return true;
    }
  }], [{
    key: "checkIfValueHasData",
    value: function checkIfValueHasData(value) {
      if (value === undefined || value === null) {
        return false;
      }
      if (value instanceof Array) {
        return value.length > 0;
      }
      if (_typeof__default["default"](value) === 'object') {
        return _Object$keys__default["default"](value).length > 0;
      }
      return true;
    }
  }]);
}();

exports.Pattern = Pattern;
exports.versionNumber = versionNumber;
